import cloneDeep from 'lodash.clonedeep';
import _differenceWith from 'lodash.differencewith';
import findIndex from 'lodash.findindex';
import groupBy from 'lodash.groupby';
import isEqual from 'lodash.isequal';
import reduce from 'lodash.reduce';
import MobileDetect from 'mobile-detect';
import moment from 'moment';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import * as memberProfileActions from '../actions/memberProfileActions';
import * as commonStateActions from '../actions/commonStateAction';
import { showReportV2Modal } from '../actions/commonStateAction';
import * as conversationInboxAction from '../actions/conversationInboxAction';
import * as eventActions from '../actions/eventActions';
import * as newFeedActions from '../actions/newFeedAction';
import * as userActions from '../actions/userActions';
import urls from '../api/urls';
import { CHROME, CHROME_IOS, CRIOS, EDGE, FIREFOX, FIREFOX_IOS, FXIOS, IE, MSIE, OPERA, SAFARI, VERSION } from '../constants/browserTypes';
import {
  CATEGORY_ID,
  CATEGORY_ITEM_ICON,
  CATEGORY_LABEL_SHOW_TYPE,
  CATEGORY_LOOKING_FOR_ITEM_LABEL,
  CATEGORY_NUMBER,
  DEFAULT_AGE_RANGE,
  LAST_CATEGORY_SCREEN,
  MEMBER_SEARCH_SCREEN,
  ON_THE_GROUND_LOOKUP_TYPE,
  SEX_TYPE,
  TYPE_ALERT_DESTINATION,
  UPDATE_INFO_STEP,
} from '../constants/category';
import {
  AddPhoneNumber,
  AVATAR_COLOR_RANGE,
  BROWSER_CLICK,
  COLOR_MEMBER_TYPE,
  COMMENT_MESSAGE_CONTENT_TYPE,
  CONVERSATION_STATUS,
  DATE_FORMAT,
  DEEP_LINKING_APP,
  DEEP_LINKING_APP_UPGRADE_EXTRAS,
  DEFAULT_FOLDER_OPTION,
  DEFAULT_HEIGHT,
  DEFAULT_PAGE_SIZE_ACTIVE_USERS,
  DEFAULT_SYSTEM,
  FONT_SIZES,
  FRIENDS_FAVOURITES_FILTER_OPTION,
  GROUP_ALERT_TYPE,
  IMAGE_ACTION_TYPE,
  IntroducingBoost,
  MEMBER_LEVEL,
  MEMBER_TYPES,
  MOMENT_RELATIVE_TIME,
  OnBoardingNotification,
  OPERATING_SYSTEM,
  PAGING_DEFAULT,
  PAYMENT_GATEWAY,
  PRIMARY_FILTER,
  QUICK_REG_TYPE,
  SCREENS_NAME,
  SECONDARY_FILTER,
  SESSIONS,
  STYLE_MODAL,
  THEMES,
  TiredOfRememberingPassword,
  TYPE_OPEN_URL,
  UPGRADE_MEMBER_SHIP_ID,
  UPGRADE_PATH_TYPE,
  UPGRADE_TYPE,
  VIDEO_FILE_TYPES,
  AUDIO_FILE_TYPES,
} from '../constants/constants';
import { SELECT_CONVERSATION_BY_IN_APP } from '../constants/eventTypes';
import { AGE_RANGE_DEFAULT } from '../constants/lookingToMeet';
import { MEMBER_TYPE_GROUPS, MEMBER_TYPES_REGISTER } from '../constants/memberTypesRegister';
import * as messageTypes from '../constants/messageTypes';
import { TYPE_VIDEO_FILE, TYPE_AUDIO_FILE } from '../constants/messageTypes';
import { AUTHORIZE, HOME, QUICK_REGISTRATION, ROOT_FOLDER, TRANSFORM_PAGE } from '../constants/routes';
import { NOT_ALLOW_ERROR, NOT_READ_ABLE_ERROR, SECURITY_ERROR } from '../constants/videoRequestType';
import { PrivacyOptionsValue } from '../enum/GroupEnum';
import config from '../libs/webIMConfig';
import chatMessage from '../models/chatMessage';
import RoundBorderModel from '../models/roundBorderTab';
import * as GoogleService from '../services/googleService';
import memberProfileService from '../services/memberProfileService';
import { getStore } from '../store/myStore';
import {
  icCircleSuccess,
  icCircleSuccessBlack,
  icDiamondMember,
  icNotificationWrong,
  icPartyPopper,
  icTickCircle,
  noPhoto,
} from '../themes/ImagesSVG';
import { getKey } from './storageHelper';
import eventDetail from 'redhotpie-shared-lib/models/eventDetail';
// import {IDateObj} from "../types/datesObj";

// const MobileDetect = require('mobile-detect');
const configApp = require('../../app');

const isNative = !configApp || !configApp.isWebApp;
const isMobileWeb = !isNative && phoneDetect();

const THRESHOLD = 0;
// custom prototype
// eslint-disable-next-line no-extend-native
Date.prototype.addDays = function (days) {
  const date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

/**
 * Only for web
 * @param ref
 * @param callback
 * @returns {*}
 */
export const useIsOverflow = (ref, callback) => {
  const [isOverflow, setIsOverflow] = useState(undefined);

  useLayoutEffect(() => {
    const { current } = ref;

    const trigger = () => {
      const hasOverflow = current.scrollHeight > current.clientHeight;

      setIsOverflow(hasOverflow);

      if (callback) {
        callback(hasOverflow);
      }
    };

    if (current) {
      // if ('ResizeObserver' in window) {
      //   new ResizeObserver(trigger).observe(current);
      // }

      trigger();
    }
  }, [callback, ref]);

  return isOverflow;
};

/**
 * Only for web
 *
 * function App() {
  const [count, setCount] = React.useState(0);

  const handleClickOutside = () => {
    setCount(0);
  };

  const ref = useOutsideClick(handleClickOutside);

  const handleClick = () => {
    setCount((state) => state + 1);
  };

  const handleHeaderClick = (event) => {
    // do something

    event.stopPropagation(); // Prevent click in parent
  };

  return (
    <div style={style} onClick={handleHeaderClick}>
      <div>Header</div>
      <button ref={ref} type="button" onClick={handleClick}>
        Count: {count}
      </button>
    </div>
  );
}
 *
 *
 * @param callback
 * @returns {*}
 */
export const useOutsideClick = callback => {
  const ref = useRef();

  useEffect(() => {
    const handleClick = event => {
      if (ref.current && !ref.current.contains(event.target) && typeof callback === 'function') {
        callback();
      }
    };

    if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) {
      document.addEventListener('touchstart', handleClick, true);
    } else {
      document.addEventListener('click', handleClick, true);
    }

    return () => {
      document.removeEventListener('touchstart', handleClick, true);
      document.removeEventListener('click', handleClick, true);
    };
  }, [ref, callback]);

  return ref;
};

/**
 * Only for Web
 * @returns {number}
 */
export const useScrollbarWidth = () => {
  const didCompute = useRef(false);
  const widthRef = useRef(0);

  if (didCompute.current) {
    return widthRef.current;
  }

  // Creating invisible container
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll'; // forcing scrollbar to appear
  outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
  document.body.appendChild(outer);

  // Creating inner element and placing it in the container
  const inner = document.createElement('div');
  outer.appendChild(inner);

  // Calculating difference between container's full width and the child width
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  // Removing temporary elements from the DOM
  outer.parentNode.removeChild(outer);

  didCompute.current = true;
  widthRef.current = scrollbarWidth;

  return scrollbarWidth;
};

/**
 * Only for Web
 * @returns {string}
 */
const useScrollDirection = () => {
  const [scrollDirection, setScrollDirection] = useState('up');

  const blocking = useRef(false);
  const prevScrollY = useRef(0);

  useEffect(() => {
    prevScrollY.current = window.pageYOffset;

    const updateScrollDirection = () => {
      const scrollY = window.pageYOffset;

      if (Math.abs(scrollY - prevScrollY.current) >= THRESHOLD) {
        const newScrollDirection = scrollY > prevScrollY.current ? 'down' : 'up';

        setScrollDirection(newScrollDirection);

        prevScrollY.current = scrollY > 0 ? scrollY : 0;
      }

      blocking.current = false;
    };

    const onScroll = () => {
      if (!blocking.current) {
        blocking.current = true;
        window.requestAnimationFrame(updateScrollDirection);
      }
    };

    window.addEventListener('scroll', onScroll);

    return () => window.removeEventListener('scroll', onScroll);
  }, [scrollDirection]);

  return scrollDirection;
};

export function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

export function deviceType() {
  if (isNative) {
    // PhoneGap Mobile App
    return 'MobileApp';
  }
  if (phoneDetect()) {
    // Mobile Browser
    return 'Mobile';
  }
  return 'Desktop';
}

export function osType() {
  if (isNative) {
    return WebIM.config.DeviceOS;
  }
  return getOS();
}

export function getExtensionFileString(fileName) {
  if (fileName) {
    return fileName.split('.').pop();
  }
  return fileName;
}

export function isObjectUndefinedOrNull(obj) {
  return obj === undefined || obj === 'null';
}

export function isEmptyString(str) {
  return str === undefined || str === '' || str === '';
}

export function isSameDay(currentMessage = {}, diffMessage = {}) {
  if (!diffMessage.createdAt) {
    return false;
  }

  const currentcreatedAt = moment(currentMessage.createdAt);
  const diffcreatedAt = moment(diffMessage.createdAt);

  if (!currentcreatedAt.isValid() || !diffcreatedAt.isValid()) {
    return false;
  }

  return currentcreatedAt.isSame(diffcreatedAt, 'day');
}

export function isSameUser(currentMessage = {}, diffMessage = {}) {
  return (currentMessage.bySelf && diffMessage.bySelf) || (!currentMessage.bySelf && !diffMessage.bySelf);
}

export function warnDeprecated(fn) {
  return (...args) => {
    return fn(...args);
  };
}

export function copyMessage(message, tpl) {
  const obj = { from: '', to: '', isPrivate: false, isModerator: false };
  Object.keys(tpl).forEach(v => {
    obj[v] = message[v] || tpl[v];
  });
  return obj;
}

export function parseRefMessageToMessageModel(msg) {
  if (msg && msg.refMsgId) {
    const newMessage = new chatMessage();
    newMessage.id = msg.refMsgId;
    newMessage.from = String(msg.refUserId);
    if (!msg.body) {
      msg.body = {};
    }
    msg.body.data = msg.refMsgShortDesc;
    msg.body.type = msg.refMsgType;
  }
  return msg;
}

export function randomColorAvatar(str) {
  let charCode = 0;
  if (str && str.length) {
    charCode = str.charCodeAt(0) + str.length;
  }
  const index = charCode % AVATAR_COLOR_RANGE.length;
  return AVATAR_COLOR_RANGE[index < AVATAR_COLOR_RANGE.length ? index : 0];
}

export function convertNumberToMonthFormat(month) {
  switch (parseInt(month)) {
    case 1:
      return 'Jan';
    case 2:
      return 'Feb';
    case 3:
      return 'Mar';
    case 4:
      return 'Apr';
    case 5:
      return 'May';
    case 6:
      return 'Jun';
    case 7:
      return 'Jul';
    case 8:
      return 'Aug';
    case 9:
      return 'Sep';
    case 10:
      return 'Oct';
    case 11:
      return 'Nov';
    default:
      return 'Dec';
  }
}

export function getFormattedDate(dateString, format) {
  if (isObjectUndefinedOrNull(dateString) || isEmptyString(dateString)) {
    return '';
  }

  // eslint-disable-next-line no-useless-catch
  try {
    return moment(dateString).format(format || '');
  } catch (e) {
    throw e;
  }
}

export function getStrFormattedDate(dateString, format) {
  if (!dateString) {
    return '';
  }
  const expFormat = format || DATE_FORMAT.CHAT_TIME;
  const dayText = getFormattedDate(dateString, expFormat);
  let yesterday = new Date();
  yesterday = yesterday.setDate(yesterday.getDate() - 1);
  if (dayText === getFormattedDate(new Date(), expFormat)) {
    return moment(dateString).format(DATE_FORMAT.HOURS_12);
  } else if (dayText === getFormattedDate(yesterday, expFormat)) {
    return 'Yesterday';
  }
  return moment(dateString).format(expFormat || '');
}

export function getHiddenMsg(msg) {
  if (msg && msg.expts > 0) {
    const currentTs = Date.parse(new Date());
    return currentTs > msg.expts;
  }
  return false;
}

export function updateQueryStringParameter(uri, key, value) {
  const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
  const separator = uri.indexOf('?') !== -1 ? '&' : '?';
  if (uri.match(re)) {
    return uri.replace(re, `$1${key}=${value}$2`);
  }
  return `${uri + separator + key}=${value}`;
}

export function checkQueryStringParameter(uri, key) {
  const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');

  return !!uri.match(re);
}

/** *
 * This is a function help us clean other keys out of object
 * @param keepKeys //array keys of object need keep. Use Object.keys(obj) to get keys of object
 * @param obj //object need clean
 */
export function cleanObjectKeys(keepKeys = [], obj) {
  if (obj !== null && obj !== undefined) {
    Object.keys(obj).forEach(key => {
      if (keepKeys.indexOf(key) === -1) {
        delete obj[key];
      }
    });
  }
  return obj;
}

export function datetimeToTimeStamp(dateTimeStr) {
  return +new Date(dateTimeStr);
}

export function getUnreadConverstionCount(conversations, isGetGift) {
  if (conversations && conversations.length > 0) {
    const searchCriteria = {
      primaryIndex: PRIMARY_FILTER.ALL,
      secondaryIndex: SECONDARY_FILTER.MESSAGES_NOT_READ,
    };
    const unreadConversations = filterConversations(searchCriteria, conversations);
    const unReadGifts = unreadConversations?.filter(item => item.hasUnreadGifts)?.length;
    return isGetGift ? { count: unreadConversations.length, unreadGifts: unReadGifts } : unreadConversations.length;
  }
  return 0;
}

export function getUnrepliedConverstionCount(conversations, isGetGift) {
  if (conversations && conversations.length > 0) {
    const searchCriteria = {
      primaryIndex: PRIMARY_FILTER.ALL,
      secondaryIndex: SECONDARY_FILTER.MESSAGE_NOT_REPLIED,
    };
    const unrepliedConversations = filterConversations(searchCriteria, conversations);
    const unReadGifts = unrepliedConversations?.filter(item => item.hasUnreadGifts)?.length;
    return isGetGift ? { count: unrepliedConversations.length, unreadGifts: unReadGifts } : unrepliedConversations.length;
  }
  return 0;
}

export function getSentConverstionCount(conversations) {
  if (conversations && conversations.length > 0) {
    const searchCriteria = {
      primaryIndex: PRIMARY_FILTER.ALL,
      secondaryIndex: SECONDARY_FILTER.MESSAGE_SENT,
    };
    const sentConversations = filterConversations(searchCriteria, conversations);
    return sentConversations.length;
  }
  return 0;
}

export function getMatchingConverstionCount(conversations) {
  if (conversations && conversations.length > 0) {
    const searchCriteria = {
      primaryIndex: PRIMARY_FILTER.MATCHING,
      secondaryIndex: SECONDARY_FILTER.ALL_MESSAGES,
    };
    const matchingConversations = filterConversations(searchCriteria, conversations);
    return matchingConversations.length;
  }
  return 0;
}

export function getMatchingUnreadConversationCount(conversations, isGetGift) {
  if (conversations && conversations.length > 0) {
    const searchCriteria = {
      primaryIndex: PRIMARY_FILTER.MATCHING,
      secondaryIndex: SECONDARY_FILTER.MESSAGES_NOT_READ,
    };
    const matchingConversations = filterConversations(searchCriteria, conversations);
    const unReadGifts = matchingConversations?.filter(item => item.hasUnreadGifts)?.length;
    return isGetGift ? { count: matchingConversations.length, unreadGifts: unReadGifts } : matchingConversations.length;
  }
  return 0;
}

export function getMatchingUnrepliedConversationCount(conversations, isGetGift) {
  if (conversations && conversations.length > 0) {
    const searchCriteria = {
      primaryIndex: PRIMARY_FILTER.MATCHING,
      secondaryIndex: SECONDARY_FILTER.MESSAGE_NOT_REPLIED,
    };
    const matchingConversations = filterConversations(searchCriteria, conversations);
    const unReadGifts = matchingConversations?.filter(item => item.hasUnreadGifts)?.length;
    return isGetGift ? { count: matchingConversations.length, unreadGifts: unReadGifts } : matchingConversations.length;
  }
  return 0;
}

export function getMatchingSentConversationCount(conversations, isGetGift) {
  if (conversations && conversations.length > 0) {
    const searchCriteria = {
      primaryIndex: PRIMARY_FILTER.MATCHING,
      secondaryIndex: SECONDARY_FILTER.MESSAGE_SENT,
    };
    const sentConversations = filterConversations(searchCriteria, conversations);
    const unReadGifts = sentConversations?.filter(item => item.hasUnreadGifts)?.length;
    return isGetGift ? { count: sentConversations.length, unreadGifts: unReadGifts } : sentConversations.length;
  }
  return 0;
}

export function getNonMatchingConversationCount(conversations, isGetGift) {
  if (conversations && conversations.length > 0) {
    const searchCriteria = {
      primaryIndex: PRIMARY_FILTER.ALL,
      secondaryIndex: SECONDARY_FILTER.MESSAGE_NON_MATCHING,
    };
    const nonMatchingConversations = filterConversations(searchCriteria, conversations);
    const unReadGifts = nonMatchingConversations?.filter(item => item.hasUnreadGifts)?.length;
    return isGetGift
      ? {
          count: nonMatchingConversations.length,
          unreadGifts: unReadGifts,
        }
      : nonMatchingConversations.length;
  }
  return 0;
}

export function getIgnoredConversationCount(conversations, isGetGift) {
  if (conversations && conversations.length > 0) {
    const searchCriteria = {
      primaryIndex: PRIMARY_FILTER.ALL,
      secondaryIndex: SECONDARY_FILTER.MESSAGES_IGNORED,
    };
    const data = filterConversations(searchCriteria, conversations);
    const unReadGifts = data?.filter(item => item.hasUnreadGifts)?.length;
    return isGetGift ? { count: data.length, unreadGifts: unReadGifts } : data.length;
  }
  return 0;
}

export function getFoldersConversationCount(conversations) {
  const res = {};
  conversations.forEach(conv => {
    if (conv.folders.length > 0 && conv.message && conv.message.createdAt && conv.unreadCount > 0 && !conv.isIgnored) {
      conv.folders.forEach(fol => {
        if (!res[fol]) {
          res[fol] = 1;
        } else {
          res[fol] += 1;
        }
      });
    }
  });
  return res;
}

export function getFoldersConversationCountWithGifts(conversations) {
  const res = {};
  conversations.forEach(conv => {
    if (conv.folders.length > 0 && conv.message && conv.message.createdAt && conv.unreadCount > 0 && !conv.isIgnored) {
      conv.folders.forEach(fol => {
        if (!res[fol]) {
          res[fol] = { count: 1 };
        } else {
          res[fol] = { count: res[fol].count + 1 };
        }
        res[fol] = { ...res[fol], hasUnreadGifts: conv.hasUnreadGifts };
      });
    }
  });
  return res;
}

// export function getIgnoredMatchConversationCount(conversations) {
//     if (conversations && conversations.length > 0) {
//         let searchCriteria = {
//           primaryIndex: PRIMARY_FILTER.MATCHING,
//           secondaryIndex: SECONDARY_FILTER.MESSAGES_IGNORED
//         };
//         let data = filterConversations(searchCriteria, conversations);
//         return data.length;
//     }
//     return 0;
// }

/*
  keptConversations: array of conversation id, type: number
 */
export function filterConversations(searchCriteria = {}, conversations, keptConversations = []) {
  const primaryIndex = searchCriteria.secondaryIndex === SECONDARY_FILTER.MESSAGE_SENT ? PRIMARY_FILTER.ALL : searchCriteria.primaryIndex;
  let primaryConversations = [];
  // console.log('primaryIndex', primaryIndex)
  switch (primaryIndex) {
    case PRIMARY_FILTER.ALL: {
      primaryConversations = [...conversations];
      break;
    }

    case PRIMARY_FILTER.MATCHING: {
      primaryConversations = [
        ...conversations.filter(e => {
          return e.peerVcard.isMatch || e.pinned || keptConversations.includes(e.id);
        }),
      ];
      break;
    }
    default:
      break;
  }
  // console.log('primaryConversations', primaryConversations)
  return searchConversations(searchCriteria.keyword, searchCriteria.secondaryIndex, primaryConversations, keptConversations);
}

export function checkIsExistInMatchingList(id) {
  const { matchingUsers } = getStore().getState().loginReducer;
  const matchingUser = matchingUsers.filter(matchingId => matchingId === id);
  return matchingUser && matchingUser.length > 0;
}

export function isVideoFile(file) {
  return VIDEO_FILE_TYPES.includes(file?.fileType) || file?.body?.type === TYPE_VIDEO_FILE;
}

export function isAudioFile(file) {
  return AUDIO_FILE_TYPES.includes(file?.fileType) || file?.body?.type === TYPE_AUDIO_FILE;
}

export function isImageExpired(image) {
  if (image && image.expts === 0) {
    return false;
  }
  return !image || image.expts < 0 || new Date(image.expts) <= new Date();
}

export function checkSameString(nameFilter, nameWantCheck) {
  let encodeFilter = '';
  if (nameFilter.length > 0) {
    const tmpRex = new RegExp(`[ \`!@#$%^&*()_+\\-=\\[\\]{};':"\\\\|,.<>\\/?~]`);
    for (let i = 0; i < nameFilter.length; i++) {
      const char = nameFilter.charAt(i);
      if (tmpRex.test(char)) {
        encodeFilter += `\\${char}`;
      } else {
        encodeFilter += char;
      }
    }
  }
  const rex = new RegExp(`(${encodeFilter})`, 'ig');

  return rex.test(nameWantCheck);
}

export function isMsgExpired(msg) {
  if (msg && msg.expts === 0) {
    return false;
  }
  return !msg || msg.expts < 0 || new Date(msg.expts) <= new Date();
}

/*
  keptConversations: array of conversation id, type: number
 */
export function searchConversations(
  keyword = '',
  secondaryIndex = 0,
  conversationsSearch = [],
  keptConversations = [],
  isFolderSearch = false
) {
  // console.log("conversations", conversations.length)
  // console.log("secondaryIndex", secondaryIndex)
  let conversations = conversationsSearch || [];
  // Step 1: Filter conversation with all filter in reducer
  const { filters } = getStore().getState().conversationsReducer;
  if (filters.isHasChangeFilter) {
    const listGender = filters.showMeMemberType.contentTabs[0].data;
    const memberTypeFilter = listGender[0].active ? listGender.map(d => d.id) : listGender.filter(d => d.active).map(d => d.id); //filter multiple gender
    conversations = conversations.filter(con => {
      const { isVerified, memberTypeId, age1, age2, countryId, stateId } = con.peerVcard;
      let res = null;
      if ((!filters.isVerified || filters.isVerified === isVerified) && (listGender[0].active || memberTypeFilter.includes(memberTypeId))) {
        const higherAge = (!age2 || age1 > age2 ? age1 : age2) || MEMBER_SEARCH_SCREEN.FILTER_AGE_RANGE.MAX_AGE;
        const lowerAge = (!age2 || age1 < age2 ? age1 : age2) || MEMBER_SEARCH_SCREEN.FILTER_AGE_RANGE.MIN_AGE;
        if ((filters.minAge <= higherAge && higherAge <= filters.maxAge) || (filters.minAge <= lowerAge && lowerAge <= filters.maxAge)) {
          if (filters.location) {
            if (filters.location.placeIdParent && filters.location.placeId && countryId === filters.location.placeIdParent) {
              /**
               * filters.location.placeId = -1: Search with all Region
               *                          = -2: Search with other region
               *                          = > 0: Search with region ID
               */
              switch (filters.location.placeId) {
                case -1:
                  res = con;
                  break;
                case -2:
                  if (!stateId) {
                    res = con;
                  }
                  break;
                default:
                  if (stateId === filters.location.placeId) {
                    res = con;
                  }
                  break;
              }
            }
          } else {
            res = con;
          }
        }
      }

      return res;
    });
  }
  // Step 2: Filter conversation with another filter
  const isMobile = isNative || isMobileWeb;
  if (isMobile) {
    if (keyword) {
      return [
        ...conversations.filter(e => {
          return checkSameString(keyword.toLowerCase(), e.peerVcard.displayName.toLowerCase().replace(/\s/g, '')) && !e.isDelete;
        }),
      ];
    }
  }
  if (secondaryIndex === SECONDARY_FILTER.ALL_MESSAGES) {
    // return conversations.map((conv, index) => {
    //   if (conv.peerVcard.userId === 1108455037579) {
    //     console.log("conv reject", conv, index);
    //   }
    //   if (!conv.isActive) {
    //     return null;
    //   }
    //   return conv;
    // }).filter(c => c !== null);
    // eslint-disable-next-line no-param-reassign
    conversations = conversations.filter(conv => {
      if (conv.pinned && !conv.isDelete) return true;
      if (!keyword && ((conv.isIgnored && !isFolderSearch) || conv.isDelete)) {
        return false;
      }
      let checkKeyWord = true;
      // Mean in case without keyword, we check this condition is true in every case, else check by displayName does contain keyword or not
      if (keyword) {
        checkKeyWord =
          checkSameString(keyword.toLowerCase(), conv.peerVcard.displayName.toLowerCase().replace(/\s/g, '')) && !conv.isDelete;
      }
      if (conv.isGroup) {
        if (conv.isDelete && conv.unreadCount === 0) {
          return false;
        }
        return (checkKeyWord && conv.pinned) || (checkKeyWord && (isFolderSearch || (!isFolderSearch && conv.isInboxRetention)));
      }
      if (conv.message && conv.message.createdAt) {
        // Do not get conversation which is not active and bySelf === true
        // return (e.message && e.message.createdAt && xmppIdTo !== xmppIdMe && !e.isActive && !e.isGroup) || keptConversations.includes(e.id);
        if (isFolderSearch || (!isFolderSearch && conv.isInboxRetention) || conv.pinned || keyword) {
          if ((conv.isActive || (!conv.isActive && isFolderSearch) || conv.pinned) && checkKeyWord) {
            return true;
          }
          if (!isMobile) {
            // only for desktop: to show all conversations searched by text without conversation in folder
            if (keyword && checkKeyWord && !isFolderSearch) {
              return true;
            }
          }
          return !(conv.message.bySelf === true || conv.message.from === '') && checkKeyWord;
        }
      }
      return false;
    });
  }
  // eslint-disable-next-line default-case
  if (!isFolderSearch) {
    switch (secondaryIndex) {
      // case SECONDARY_FILTER.MESSAGES_FRIEND_AND_FAVOURITE: {
      //     let friends = getStore().getState().friendsAndFavoritesReducer
      //         .data;
      //     conversations = conversations.filter(e => {
      //         let otherUser = e.peerVcard;
      //         let friend = friends.filter(
      //             f => f.xmppId.toString() === otherUser.xmppId.toString()
      //         );
      //         return (e.message && e.message.createdAt && friend && friend.length > 0) || keptConversations.includes(e.id);
      //     });
      //     break;
      // }

      case SECONDARY_FILTER.MESSAGES_NOT_READ: {
        conversations = conversations.filter(e => {
          return (e.message && e.message.createdAt && e.unreadCount > 0 && !e.isIgnored && !e.isDelete) || keptConversations.includes(e.id);
        });
        break;
      }

      case SECONDARY_FILTER.MESSAGES_READ: {
        conversations = conversations.filter(e => {
          return (
            (e.message && e.message.createdAt && e.unreadCount === 0 && !e.isIgnored && !e.isDelete) || keptConversations.includes(e.id)
          );
        });
        break;
      }

      case SECONDARY_FILTER.MESSAGE_NOT_REPLIED: {
        const xmppIdMe = getStore().getState().loginReducer.userInfo.xmppId;
        conversations = conversations.filter(e => {
          const xmppIdTo = e.message.to;
          return (
            (e.message && e.message.createdAt && xmppIdTo === xmppIdMe && !e.isIgnored && !e.isGroup && !e.isDelete) ||
            keptConversations.includes(e.id)
          );
        });
        break;
      }

      case SECONDARY_FILTER.MESSAGE_SENT: {
        const xmppIdMe = getStore().getState().loginReducer.userInfo.xmppId;
        conversations = conversations.filter(e => {
          const xmppIdTo = e.message.to;
          return (
            (e.message && e.message.createdAt && xmppIdTo !== xmppIdMe && !e.isActive && !e.isGroup && !e.isDelete) ||
            keptConversations.includes(e.id)
          );
        });
        break;
      }

      case SECONDARY_FILTER.MESSAGE_NON_MATCHING: {
        // console.log("conversations", conversations);
        conversations = conversations.filter(conv => {
          if (conv.isIgnored || conv.isDelete) {
            return false;
          }

          if ((conv.message && conv.message.createdAt && !conv.peerVcard.isMatch && !conv.isGroup) || keptConversations.includes(conv.id)) {
            if (conv.isActive) {
              return true;
            }
            // return false;
            return !(conv.message.bySelf === true || conv.message.from === '');
          }
          return false;
          // Do not get conversation which is not active and bySelf === true
        });

        // console.log("conversationsEdited", conversations);
        break;
      }

      case SECONDARY_FILTER.MESSAGES_IGNORED: {
        conversations = conversations.filter(c => c.isIgnored && !c.isDelete);
        break;
      }
    }
  }

  if (!isMobile) {
    if (keyword) {
      return [
        ...conversations.filter(e => {
          return checkSameString(keyword.toLowerCase(), e.peerVcard.displayName.toLowerCase().replace(/\s/g, '')) && !e.isDelete;
        }),
      ];
    }
  }
  // console.log('searchConversations', keyword, conversations)
  return conversations;
}

export function separateConversation(conversationAll, pinCount, undetectedConversations) {
  const {
    conversationsReducer: { unreadMatchingConversations, unreadConversations },
    foldersReducer: { folderSelected },
    loginReducer: { userInfo },
  } = getStore().getState();
  const unreadCount =
    userInfo.messenger.defaultFolder === DEFAULT_FOLDER_OPTION.ALL ? unreadConversations : unreadMatchingConversations || 0;
  const unreadConversationCount =
    conversationAll.filter(e => {
      return e.message && e.message.createdAt && e.unreadCount > 0 && !e.isIgnored;
    }) || [];
  const unreadOtherCount = unreadCount - unreadConversationCount.length;

  const conversations = (undetectedConversations &&
    undetectedConversations.length > 0 &&
    [...conversationAll].slice(undetectedConversations.length, conversationAll.length)) || [...conversationAll];
  const dataPinned = [];
  let dataUnpinned = [];

  /*
      Cause conversations has pinned at first, then conversation data, so we just get conversation pinned by field pinned
      Maximum pinCount is 5, so performance is good for this case
     */
  if (conversations) {
    if (conversations.length < pinCount) {
      // eslint-disable-next-line no-param-reassign
      pinCount = conversations.length;
    }
    for (let i = 0; i < pinCount; i += 1) {
      if (conversations[i].pinned) {
        dataPinned.push(conversations[i]);
      }
    }
    dataUnpinned = conversations.slice(dataPinned.length, conversations.length);
  }
  if (undetectedConversations && undetectedConversations.length > 0) {
    undetectedConversations.forEach(item => {
      item.pinned ? dataPinned.unshift(item) : dataUnpinned.unshift(item);
    });
  }
  return {
    dataPinned,
    data: dataUnpinned,
    unreadOtherCount: unreadOtherCount < 0 ? 0 : unreadOtherCount,
  };
}

export function showConversationPinned(conversations, showAll = false) {
  if (showAll) {
    return [...conversations];
  }
  let pinnedListShow = [...conversations].filter(e => {
    return e.unreadCount > 0;
  });
  let indexShowUnread = pinnedListShow.length;
  if (indexShowUnread < DEFAULT_SYSTEM.LIMIT_CONVERSATION_PINNED) {
    indexShowUnread = DEFAULT_SYSTEM.LIMIT_CONVERSATION_PINNED;
    if (conversations.length > indexShowUnread) {
      pinnedListShow = conversations.slice(0, indexShowUnread);
    } else {
      pinnedListShow = conversations;
    }
  }
  return pinnedListShow;
}

export function getConversationInfo(xmppId, conversations) {
  try {
    const conversationIndex = findIndex(conversations, e => {
      return e.peerVcard.xmppId === xmppId;
    });
    /* conversationIndex = conversations.findIndex(e => {
          return e.peerVcard.xmppId === xmppId;
        }); */
    return conversationIndex;
  } catch (e) {
    return null;
  }
}

/** *
 * This function with compare deep each object in arrObjects with arrDiffWith, if have diff object or 1 object have diff value ==> return array[diffObject]
 * @param arrObjects ==> ex:  [{ 'x': 1, 'y': 1 }, { 'x': 2, 'y': 2 }, { 'x': 3, 'y': 3 }]
 * @param arrDiffWith ==> ex: [{ 'x': 1, 'y': 1 }, { 'x': 2, 'y': 2 }]
 * @returns {boolean} ==> ex: [{ 'x': 3, 'y': 3 }]
 */
export function differenceWith(arrObjects, arrDiffWith) {
  return _differenceWith(arrObjects, arrDiffWith, isEqual);
}

export function getEditorStatus(canSend, memberType, chatted) {
  if (canSend) {
    return CONVERSATION_STATUS.NORMAL;
  }
  // canSend = false & memberType = guest
  if (!memberType || memberType === MEMBER_TYPES.GUEST) {
    return CONVERSATION_STATUS.GET_ACCESS;
  }

  // canSend = false & memberType != guest
  return chatted ? CONVERSATION_STATUS.MESSAGE_RESET_24H : CONVERSATION_STATUS.GET_ACCESS_MORE;
}

export function convertCanvasIntoFile(dataURL) {
  if (dataURL) {
    const blobBin = atob(dataURL.split(',')[1]);
    const array = [];
    for (let i = 0; i < blobBin.length; i++) {
      array.push(blobBin.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type: 'image/png' });
  }
  return null;
}

export function loadMoreFriendsAndFavourites(pageNumber, data) {
  return [...data].splice(0, pageNumber * PAGING_DEFAULT.PAGE_SIZE_FRIEND);
}

export function filterFriendsAndFavourites(option, data) {
  if (option === FRIENDS_FAVOURITES_FILTER_OPTION.ACTIVE) {
    return [...data].filter(e => e.online);
  }
  return data;
}

export function formatNumberIntoKorMCount(count) {
  if (count.toString().length > 0) {
    if (count.toString().length > 3) {
      return '999+';
    }
    return count.toString();
  }
  return '';
}

const isObject = obj => {
  return ((typeof obj === 'object' || Array.isArray(obj) === true) && obj !== null) || typeof obj === 'function';
};

const isArrayEqual = (array1 = [], array2 = []) => {
  if (array1 === array2) {
    return true;
  }

  // check one level deep
  return array1.length === array2.length && array1.every((item, index) => item === array2[index]);
};

export function isObjectEqual(obj1, obj2) {
  if (!isObject(obj1) || !isObject(obj2)) {
    return false;
  }

  // are the references the same?
  if (obj1 === obj2) {
    return true;
  }

  // does it contain objects with the same keys?
  const item1Keys = Object.keys(obj1).sort();
  const item2Keys = Object.keys(obj2).sort();

  if (!isArrayEqual(item1Keys, item2Keys)) {
    return false;
  }

  // does every object in props have the same reference?
  return item2Keys.every(key => {
    const value = obj1[key];
    const nextValue = obj2[key];

    if (value === nextValue) {
      return true;
    }

    // special case for arrays - check one level deep
    return Array.isArray(value) && Array.isArray(nextValue) && isArrayEqual(value, nextValue);
  });
}

export function phoneDetect() {
  let md = '';
  if (window && window.navigator && window.navigator.userAgent) {
    md = new MobileDetect(window.navigator.userAgent);
  }
  return !!md && typeof md.phone() === 'string';
}

export function tabletDetect() {
  let md = '';
  if (window && window.navigator && window.navigator.userAgent) {
    md = new MobileDetect(window.navigator.userAgent);
  }
  return md && typeof md.tablet() === 'string';
}

export function tableHorizontalDetect() {
  return window.innerWidth >= 992 && window.innerWidth <= 1024;
}

export function validateEmailFormat(email) {
  if (!email || !email.length) {
    return false;
  }
  const emailRegex =
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(email.toLowerCase());
}

export function validateUrlFormat(url) {
  if (!url || !url.length) {
    return false;
  }
  const urlRegex = new RegExp('((http|https|Http|Https)://)', 'g');

  return urlRegex.test(url);
}

export function controlScroll(isMobile, showModal) {
  if (isMobile) {
    document.ontouchmove = event => {
      if (showModal) {
        event.preventDefault();
      }
    };
  }
}

export function getSubContentByMemberTye(memberTypeId) {
  const subTabs = [];
  const youAre = new RoundBorderModel({
    id: 0,
    title: 'Registration.YouAre',
    isSelected: false,
    active: true,
  });
  const sheIs = new RoundBorderModel({
    id: 1,
    title: 'Registration.Sheis',
    isSelected: false,
  });
  const heIs = new RoundBorderModel({
    id: 1,
    title: 'Registration.Heis',
    isSelected: false,
  });
  switch (memberTypeId.toString()) {
    case MEMBER_TYPES_REGISTER.COUPLES.toString(): {
      heIs.id = 0;
      subTabs.push(heIs);
      subTabs.push(sheIs);
      return subTabs;
    }
    case MEMBER_TYPES_REGISTER.COUPLES_FF.toString(): {
      subTabs.push(youAre);
      subTabs.push(sheIs);
      return subTabs;
    }
    case MEMBER_TYPES_REGISTER.COUPLES_MM.toString(): {
      subTabs.push(youAre);
      subTabs.push(heIs);
      return subTabs;
    }
    case MEMBER_TYPES_REGISTER.MEN.toString():
    case MEMBER_TYPES_REGISTER.WOMEN.toString():
    case MEMBER_TYPES_REGISTER.GROUPS.toString():
    case MEMBER_TYPES_REGISTER.TV_CD.toString():
    case MEMBER_TYPES_REGISTER.TRANS_WOMAN.toString():
    case MEMBER_TYPES_REGISTER.TRANS_MAN.toString(): {
      return subTabs;
    }
    default:
      return subTabs;
  }
}

export function checkSelectedAll(categories, categoryId) {
  let isSelectedAll = true;
  categories.map(item => {
    if (item.id !== categoryId && !item.isSelected && !item.isSkip) {
      isSelectedAll = false;
      return { item, isSelectedAll };
    }
    return item;
  });
  return { isSelectedAll };
}

export function initCategoryByMemberType(memberType) {
  const initCategory = [];
  const userRegister = getStore().getState().userRegister || {};

  const { bodyTypes, height, orientation, age, sex, ethnicity, sexual } = userRegister;
  const tmpArray = cloneDeep([age, sex, ethnicity, bodyTypes, height, orientation, sexual]);
  tmpArray.forEach(category => {
    const newCategory = Object.assign({}, category);
    if (newCategory.id !== CATEGORY_ID.TU1_SEX) {
      const contentTabs = newCategory.contentTabs || [];
      newCategory.isSelected = false;
      newCategory.labelTop = {};
      newCategory.labelBottom = {};
      newCategory.indexTab = 0;
      if (contentTabs && contentTabs.length) {
        contentTabs.map(tab => {
          if (tab && tab.data && tab.data.length) {
            tab.data.map(item => {
              item.active = false;
              item.value = '';
              if (newCategory.id === CATEGORY_ID.TU1_AGE) {
                item.value = setDefaultAge(AGE_RANGE_DEFAULT.DEFAULT);
              }
              if (newCategory.id === CATEGORY_ID.TU2_HEIGHT) {
                item.active = item.id === DEFAULT_HEIGHT;
              }
              return item;
            });
          }
          return tab;
        });
      }
      let newContentTabs = [];

      if (newCategory.id === CATEGORY_ID.WYI_SEXUAL) {
        newContentTabs = [{ data: [] }];
      } else {
        // handle double content tab with couple
        if (
          memberType === MEMBER_TYPES_REGISTER.COUPLES ||
          memberType === MEMBER_TYPES_REGISTER.COUPLES_FF ||
          memberType === MEMBER_TYPES_REGISTER.COUPLES_MM
        ) {
          newContentTabs = [contentTabs[0], contentTabs[0]];
        } else {
          newContentTabs = [contentTabs[0]];
        }
        newCategory.subTabs = getSubContentByMemberTye(memberType);
      }
      newCategory.contentTabs = newContentTabs;
    }

    initCategory.push(newCategory);
  });

  return initCategory;
}

export function setCategoryByItem(categories, selectingCategoryId, itemId, nextCategoryId) {
  const newCategories = [];
  if (categories && categories.length) {
    categories.forEach(category => {
      const newCategory = Object.assign({}, category);
      if (category.id === selectingCategoryId) {
        newCategory.isSelected = true;
        newCategory.isSelecting = false;
        const contentTabData = cloneDeep(newCategory.contentTabs[newCategory.indexTab].data);
        const newContentData = [];
        let selectedItemCount = 0;
        if (itemId) {
          contentTabData.forEach(item => {
            const newItem = Object.assign({}, item);
            if (item.id === itemId) {
              newItem.active = true;
            } else if (category.singleSelect) {
              newItem.active = false;
            }

            if (newItem.active) {
              selectedItemCount++;
            }

            newContentData.push(newItem);
          });
          const newContentTabs = [];
          newContentTabs[newCategory.indexTab] = { data: newContentData };
          newCategory.contentTabs = newContentTabs;
          if (!selectedItemCount) {
            newCategory.isSelected = false;
          }
        }
      }
      if (category.id === nextCategoryId) {
        newCategory.isSelecting = true;
      }
      newCategories.push(newCategory);
    });
  }
  return newCategories;
}

export function backCategory(categorys, selectingCategoryId, currentScreen) {
  const _categorys = cloneDeep(categorys);
  const stepId = UPDATE_INFO_STEP.indexOf(selectingCategoryId);
  let nextCategoryId = UPDATE_INFO_STEP[stepId - 1] || selectingCategoryId;
  let isBackScreen = false;
  const selectingCategory = _categorys.find(e => e.id.toString() === selectingCategoryId.toString());
  if (selectingCategory) {
    if (selectingCategory.indexTab === 1) {
      _categorys.map(cate => {
        if (cate.id.toString() === selectingCategoryId.toString()) {
          cate.indexTab = 0;
        }
        return cate;
      });
      nextCategoryId = selectingCategoryId;
    } else {
      if (LAST_CATEGORY_SCREEN[currentScreen] === selectingCategoryId) {
        isBackScreen = true;
      }
      if (nextCategoryId === selectingCategoryId) {
        return {
          backCategoryId: nextCategoryId,
          backCategory: _categorys,
          isBackScreen,
        };
      }
      _categorys.map(cate => {
        if (cate.id === nextCategoryId) {
          cate.isSelecting = true;
        } else {
          if (cate.id !== LAST_CATEGORY_SCREEN[currentScreen]) {
            cate.isSelecting = false;
          }
        }
        return cate;
      });
    }
  }

  return {
    backCategoryId: nextCategoryId,
    backCategory: _categorys,
    isBackScreen,
  };
}

export function updateCategoryData(Category, selectingCategory, isLastCategory, isSkip, isSkipIntroduceScreen) {
  let category = cloneDeep(Category);
  const categoryId = selectingCategory.id;
  const stepId = UPDATE_INFO_STEP.indexOf(categoryId);
  let nextCategoryId = isLastCategory && isSkipIntroduceScreen ? categoryId : UPDATE_INFO_STEP[stepId + 1] || categoryId;
  const memberTypeReducer = getStore().getState().userRegister.memberType;
  let indexTab = selectingCategory.indexTab || 0;
  const subTabs = selectingCategory && selectingCategory.subTabs ? selectingCategory.subTabs : [];
  const contentTabs = selectingCategory && selectingCategory.contentTabs ? selectingCategory.contentTabs : [];
  if (categoryId === CATEGORY_ID.TU1_SEX) {
    const data = contentTabs && contentTabs[0] && contentTabs[0].data ? contentTabs[0].data : [];
    let newMemberType = MEMBER_TYPES_REGISTER.MEN;
    const activeItem = data.find(x => x.active);
    newMemberType = activeItem ? activeItem.id : newMemberType;
    if (MEMBER_TYPE_GROUPS[memberTypeReducer] !== MEMBER_TYPE_GROUPS[newMemberType]) {
      category = initCategoryByMemberType(newMemberType);
    }
  }

  const allSelectedObject = checkSelectedAll(category, categoryId);
  if (allSelectedObject && !allSelectedObject.isSelectedAll && allSelectedObject.item && !isLastCategory) {
    nextCategoryId = allSelectedObject.item.id;
  }
  if (subTabs.length > 0 && indexTab < subTabs.length - 1) {
    nextCategoryId = categoryId;
  }

  let newSelectingCategory = {};
  const newCategoryData = [];
  category.forEach(item => {
    let newItem = Object.assign({}, item);
    if (!isLastCategory) {
      newItem.isSelecting = false;
    }
    if (item.id === categoryId) {
      if (isSkip) {
        newItem.isSelected = false;
      } else {
        let isSelected = true;

        if (newItem.subTabs.length > 0) {
          const countSelected = newItem.subTabs.filter(e => e.isSelected);
          if (countSelected) {
            isSelected = countSelected.length > 0;
          }
        }
        newItem.isSelected = isSelected;
      }
      newItem = updateLabelOfCategory(newItem);
      newItem.subTabs = setSubTabTitle(selectingCategory);
    }
    if (item.id === nextCategoryId) {
      newItem.isSelecting = true;
      newSelectingCategory = newItem;
      if (nextCategoryId === categoryId) {
        if (newItem && newItem.subTabs && newItem.subTabs.length) {
          indexTab += 1;
          newItem.indexTab = indexTab;
        }
      }
    }
    newCategoryData.push(newItem);
  });

  return {
    category: newCategoryData,
    nextCategoryId,
    indexTab,
  };
}

export function updateLabelOfCategory(SelectingCategory) {
  const selectingCategory = Object.assign({}, SelectingCategory);
  selectingCategory.labelTop = {};
  selectingCategory.labelBottom = {};
  let type = CATEGORY_LABEL_SHOW_TYPE.TITLE_ON_VALUE;
  switch (selectingCategory.id) {
    // Type 1
    case CATEGORY_ID.LTM_AGE_RANGE: {
      type = CATEGORY_LABEL_SHOW_TYPE.TITLE_ON_VALUE;
      break;
    }
    case CATEGORY_ID.TU1_AGE: {
      if (selectingCategory.subTabs.length === 2) {
        type = CATEGORY_LABEL_SHOW_TYPE.PREFIX_WITH_VALUE_ON_PREFIX_WITH_VALUE;
      } else {
        type = CATEGORY_LABEL_SHOW_TYPE.TITLE_ON_VALUE;
      }
      break;
    }
    case CATEGORY_ID.TU2_HEIGHT:
      {
        if (selectingCategory.subTabs.length === 2) {
          type = CATEGORY_LABEL_SHOW_TYPE.PREFIX_WITH_VALUE_ON_PREFIX_WITH_VALUE;
        } else {
          type = CATEGORY_LABEL_SHOW_TYPE.TITLE_ON_LABEL;
        }
      }
      break;
    // Type 2
    case CATEGORY_ID.LTM_LOOKING_FOR:
    case CATEGORY_ID.LTM_INTENTIONS:
    case CATEGORY_ID.WYI_GENERAL:
    case CATEGORY_ID.WYI_SEXUAL:
    case CATEGORY_ID.WYI_FETISH: {
      type = CATEGORY_LABEL_SHOW_TYPE.TITLE_ON_COUNT;
      break;
    }

    // Type 3
    case CATEGORY_ID.TU2_ORIENTATION:
    case CATEGORY_ID.TU1_ETHNICITY: {
      if (selectingCategory.subTabs.length === 2) {
        type = CATEGORY_LABEL_SHOW_TYPE.LABEL_ON_LABEL;
      } else {
        type = CATEGORY_LABEL_SHOW_TYPE.TITLE_ON_LABEL;
      }
      break;
    }
    case CATEGORY_ID.TU2_BODY_TYPE: {
      if (selectingCategory.subTabs.length === 2) {
        type = CATEGORY_LABEL_SHOW_TYPE.PREFIX_WITH_VALUE_ON_PREFIX_WITH_VALUE;
      } else {
        type = CATEGORY_LABEL_SHOW_TYPE.TITLE_ON_LABEL;
      }
      break;
    }
    case CATEGORY_ID.TU1_SEX: {
      type = CATEGORY_LABEL_SHOW_TYPE.PREFIX_ON_VALUE;
      break;
    }

    // Type 6
    case CATEGORY_ID.IY_ABOUT_YOU:
    case CATEGORY_ID.IY_YOUR_IDEAL_MATCH: {
      type = CATEGORY_LABEL_SHOW_TYPE.TITLE;
      break;
    }
    default:
      break;
  }
  /*
     TITLE_ON_VALUE : 1,
     TITLE_ON_COUNT : 2,
     LABEL_ON_LABEL : 3,
     VALUE_ON_VALUE : 4,
     PREFIX_WITH_VALUE_ON_PREFIX_WITH_VALUE : 5,
     TITLE : 6,
     PREFIX_ON_VALUE : 7 */
  switch (type) {
    case CATEGORY_LABEL_SHOW_TYPE.TITLE_ON_VALUE: {
      selectingCategory.labelTop.key = selectingCategory.title;
      const { value } = selectingCategory.contentTabs[0].data[0];
      if (selectingCategory.unit) {
        if (selectingCategory.id === CATEGORY_ID.TU1_AGE) {
          selectingCategory.labelBottom.value = moment().diff(moment(value), 'years').toString();
        } else {
          if (selectingCategory.id === CATEGORY_ID.LTM_AGE_RANGE) {
            let min = selectingCategory.contentTabs[0].data[0].value;
            let max = selectingCategory.contentTabs[0].data[1].value;

            if (min === DEFAULT_AGE_RANGE.MAX) {
              min = DEFAULT_AGE_RANGE.MAX_TEXT;
            }

            if (max === DEFAULT_AGE_RANGE.MAX) {
              max = DEFAULT_AGE_RANGE.MAX_TEXT;
            }
            selectingCategory.labelBottom.value = `${min} - ${max}`;
          }
        }
      } else {
        selectingCategory.labelBottom.value = value;
      }
      break;
    }
    case CATEGORY_LABEL_SHOW_TYPE.TITLE_ON_COUNT: {
      selectingCategory.labelTop.key = selectingCategory.title;
      let count = 0;
      selectingCategory.contentTabs[0].data.forEach(e => {
        if (e.active) {
          count++;
        }
      });
      selectingCategory.labelBottom.value = count;
      // selectingCategory.labelBottom.unit = "Selected";
      break;
    }
    case CATEGORY_LABEL_SHOW_TYPE.LABEL_ON_LABEL: {
      const labelTop = selectingCategory.contentTabs[0].data.find(e => e.active);
      const labelBottom = selectingCategory.contentTabs[1].data.find(e => e.active);
      if (labelTop) {
        selectingCategory.labelTop.value = labelTop.label;
        selectingCategory.labelTop.key = '';
      }
      if (labelBottom) {
        selectingCategory.labelBottom.value = labelBottom.label;
        selectingCategory.labelBottom.key = '';
      }
      break;
    }
    case CATEGORY_LABEL_SHOW_TYPE.VALUE_ON_VALUE: {
      const labelTop = selectingCategory.contentTabs[0].data.find(e => e.active);
      const labelBottom = selectingCategory.contentTabs[1].data.find(e => e.active);
      selectingCategory.labelTop.value = labelTop && labelTop.label ? labelTop.label : '';
      selectingCategory.labelBottom.value = labelBottom && labelBottom.label ? labelBottom.label : '';

      break;
    }
    case CATEGORY_LABEL_SHOW_TYPE.PREFIX_WITH_VALUE_ON_PREFIX_WITH_VALUE: {
      const prefixTop = selectingCategory.subTabs[0].title;
      const prefixBottom = selectingCategory.subTabs[1].title;
      const item1 = selectingCategory.contentTabs[0].data.find(e => e.active || e.value);
      const item2 = selectingCategory.contentTabs[1].data.find(e => e.active || e.value);
      let value1 = '';
      let value2 = '';
      let id1 = '';
      let id2 = '';
      if (item1) {
        value1 = item1.active ? item1.label : item1.value;
        id1 = item1.active ? item1.id : '';
      }
      if (item2) {
        value2 = item2.active ? item2.label : item2.value;
        id2 = item2.active ? item2.id : '';
      }

      if (selectingCategory.unit) {
        if (selectingCategory.unit === 'yo') {
          if (selectingCategory.id === CATEGORY_ID.TU1_AGE) {
            value1 = moment().diff(moment(value1), 'year');
            value2 = moment().diff(moment(value2), 'year');
          }
        } else if (selectingCategory.unit === 'cm' || selectingCategory.unit === 'Unit.cm') {
          if (selectingCategory.id === CATEGORY_ID.TU2_HEIGHT) {
            const tmp1 = value1 ? value1.split(' ') : [];
            const tmp2 = value2 ? value2.split(' ') : [];

            if (id1 === 20 || id1 === 1 || id1 === 0) {
              value1 = tmp1 && tmp1[0] && tmp1[1] ? `${tmp1[0]} ${tmp1[1]}` : '';
            } else {
              value1 = tmp1 && tmp1[0] ? tmp1[0] : '';
            }

            if (id2 === 20 || id2 === 1 || id2 === 0) {
              value2 = tmp2 && tmp2[0] && tmp2[1] ? `${tmp2[0]} ${tmp2[1]}` : '';
            } else {
              value2 = tmp2 && tmp2[0] ? tmp2[0] : '';
            }
          }
        }
      }
      selectingCategory.labelTop.key = prefixTop;
      selectingCategory.labelTop.value = value1.toString();
      selectingCategory.labelBottom.key = prefixBottom;
      selectingCategory.labelBottom.value = value2.toString();
      break;
    }
    case CATEGORY_LABEL_SHOW_TYPE.TITLE: {
      selectingCategory.labelTop.key = selectingCategory.title;
      break;
    }
    case CATEGORY_LABEL_SHOW_TYPE.PREFIX_ON_VALUE: {
      const itemId = selectingCategory.contentTabs[0].data.find(e => e.active).id;
      if (
        itemId.toString() === MEMBER_TYPES_REGISTER.MEN.toString() ||
        itemId.toString() === MEMBER_TYPES_REGISTER.WOMEN.toString() ||
        itemId.toString() === MEMBER_TYPES_REGISTER.TV_CD.toString() ||
        itemId.toString() === MEMBER_TYPES_REGISTER.TRANS_MAN.toString() ||
        itemId.toString() === MEMBER_TYPES_REGISTER.TRANS_WOMAN.toString()
      ) {
        selectingCategory.labelTop.key = 'TellUsAboutYourself1.Iam';
      } else {
        selectingCategory.labelTop.key = 'TellUsAboutYourself1.We';
      }
      selectingCategory.labelBottom.value = selectingCategory.contentTabs[0].data.find(e => e.active).label;
      break;
    }
    case CATEGORY_LABEL_SHOW_TYPE.TITLE_ON_LABEL: {
      selectingCategory.labelTop.key = selectingCategory.title;
      selectingCategory.labelTop.value = '';
      const activeItem = selectingCategory.contentTabs[0].data.find(e => e.active);
      selectingCategory.labelBottom.value = activeItem ? activeItem.label : '';
      if (selectingCategory.id === CATEGORY_ID.TU2_HEIGHT) {
        const id = activeItem ? activeItem.id : '';
        const value = activeItem ? activeItem.label : '';
        const tmp = value ? value.split(' ') : [];
        if (id === 20 || id === 1 || id === 0) {
          selectingCategory.labelBottom.value = tmp && tmp[0] && tmp[1] ? `${tmp[0]} ${tmp[1]}` : '';
        } else {
          selectingCategory.labelBottom.value = tmp && tmp[0] ? tmp[0] : '';
        }
      }
      selectingCategory.labelBottom.key = '';
      break;
    }
    default:
      break;
  }
  return selectingCategory;
}

export function isValidUserName(userName) {
  // Username must contain letters, numbers and underscores only, must not start or end with an underscore.
  let isLengthValid = false;
  let specialValid = false;
  let underscoreValid = false;
  let letterNumbersValid = false;
  let usernameValidationString = '';
  const lengthAlert = 'Registration.WarningMessages.WarningInvalidUsernameLenChar'; // "Must be between 5 - 16 characters.";
  const underscoreAlert = 'Registration.WarningMessages.WarningInvalidUsernameUnderscore'; // "Can't start or end with an underscore.";
  const specialAlert = 'Registration.WarningMessages.WarningInvalidUsernameSpeChar'; // "Cant have special characters.";
  const letterNumbersAlert = 'Registration.WarningMessages.WarningInvalidUsernameChar'; // "Must contain letters, numbers and underscores only.";

  // [0-9a-zA-Z][0-9a-zA-Z_]{3,14}[0-9a-zA-Z]
  if ((userName && userName.length === 0) || !userName) {
    usernameValidationString = 'Registration.WarningMessages.WarningInvalidUsername';
  } else {
    if (!(userName.length >= 5 && userName.length <= 16)) {
      usernameValidationString = lengthAlert;
    } else {
      isLengthValid = true;
    }
    if (userName.match(new RegExp("[$&+,:;=?@#|'<>.^*()%!]"))) {
      usernameValidationString = specialAlert;
    } else {
      specialValid = true;
    }
    if (userName.charAt(0) === '_' || userName.charAt(userName.length - 1) === '_') {
      usernameValidationString = underscoreAlert;
    } else {
      underscoreValid = true;
    }
    if (!userName.match(new RegExp('[0-9a-zA-Z]'))) {
      usernameValidationString = letterNumbersAlert;
    } else {
      letterNumbersValid = true;
    }
  }

  const isValid = isLengthValid && specialValid && underscoreValid && letterNumbersValid;

  // if return true proceed to duplicate name check on the backend
  return [isValid, usernameValidationString];
}

export function isValidUserNameLogin(userName) {
  return !isEmptyString(userName);
}

export function isValidPassword(password) {
  let validationString = 'Password ';
  const lengthAlert = 'must be between 6 & 20 characters.';
  // const numberAlert = 'Must have a number. ';
  // const capitalAlert = 'Must have a capital letter. ';
  const letterError = 'Letters, numbers and underscores only.';
  // eslint-disable-next-line no-useless-escape
  const reg = /([a-zA-Z0-9\_])+$/;
  const isValid = !isEmptyString(password) && password.length >= 6 && password.length <= 20 && reg.test(password);

  if (!(password.length >= 6 && password.length <= 20)) {
    validationString += lengthAlert;
  } else {
    if (!reg.test(password)) {
      validationString = letterError;
    }
  }
  // if (!/\d/.test(password)) {
  //     //validationString += numberAlert;
  // }
  // if (!password.match(new RegExp("[A-Z]"))) {
  //     //validationString += capitalAlert;
  // }

  return [isValid, validationString];
}

export function isValidEmail(email) {
  const reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

  return !isEmptyString(email) && reg.test(email);
}

export function isSelectedCategory(data, categoryId) {
  let res = false;
  if (Array.isArray(data)) {
    data.forEach(item => {
      if (item.id === categoryId && item.isSelected) {
        res = true;
      }
    });
  }
  return res;
}

export function prepareCategoryData(category) {
  const data = {};
  if (category && Array.isArray(category)) {
    category.forEach(item => {
      switch (item.id) {
        case CATEGORY_ID.LTM_LOOKING_FOR: {
          data.lookingFor = item;
          break;
        }
        case CATEGORY_ID.LTM_AGE_RANGE: {
          data.ageRange = item;
          break;
        }
        case CATEGORY_ID.LTM_INTENTIONS: {
          data.intentions = item;
          break;
        }
        case CATEGORY_ID.TU1_SEX: {
          data.sex = item;
          break;
        }
        case CATEGORY_ID.TU1_AGE: {
          data.age = item;
          break;
        }
        case CATEGORY_ID.TU1_ETHNICITY: {
          data.ethnicity = item;
          break;
        }
        case CATEGORY_ID.TU2_BODY_TYPE: {
          data.bodyTypes = item;
          break;
        }
        case CATEGORY_ID.TU2_HEIGHT: {
          data.height = item;
          break;
        }
        case CATEGORY_ID.TU2_ORIENTATION: {
          data.orientation = item;
          break;
        }
        case CATEGORY_ID.WYI_GENERAL: {
          data.general = item;
          break;
        }
        case CATEGORY_ID.WYI_SEXUAL: {
          data.sexual = item;
          break;
        }
        case CATEGORY_ID.WYI_FETISH: {
          data.fetish = item;
          break;
        }
        case CATEGORY_ID.IY_ABOUT_YOU: {
          data.aboutYou = item;
          break;
        }
        case CATEGORY_ID.IY_YOUR_IDEAL_MATCH: {
          data.yourIdealMatch = item;
          break;
        }
        case CATEGORY_ID.MPB_PERSONALITY: {
          data.personality = item;
          break;
        }
        case CATEGORY_ID.MPB_LOOKS: {
          data.looks = item;
          break;
        }
        case CATEGORY_ID.MPB_INTERESTS: {
          data.interests = item;
          break;
        }
        case CATEGORY_ID.MPB_LOOKINGFOR: {
          data.mpbLookingFors = item;
          break;
        }
        default:
          break;
      }
    });
  }
  return data;
}

export function setSelectingCategory(category, id) {
  const newCategory = [];
  if (category && Array.isArray(category)) {
    category.forEach(item => {
      const newItem = Object.assign({}, item);
      newItem.isSelecting = false;
      if (item.id === id) {
        newItem.isSelecting = true;
      }
      newCategory.push(newItem);
    });
  }
  return newCategory;
}

export function getSelectingCategory(data) {
  let selectingCategory = null;
  if (data && Array.isArray(data)) {
    data.forEach(item => {
      if (item.isSelecting) {
        selectingCategory = item;
      }
    });
  }

  return selectingCategory;
}

export function checkCategoryHasValue(selectingCategory) {
  let countTab = 0;
  let countTabHasValue = 0;
  selectingCategory.contentTabs.forEach(tab => {
    countTab++;
    tab.data.forEach(item => {
      if ((item.active || item.value) && countTabHasValue < countTab) {
        countTabHasValue++;
      }
    });
  });

  return countTab === countTabHasValue;
}

export function checkCanNext(selectingCategory, tabId) {
  const contentTabs = selectingCategory && selectingCategory.contentTabs ? selectingCategory.contentTabs : [];
  const indexTab = tabId !== undefined ? tabId : selectingCategory.indexTab;
  let hasValue = false;
  if (contentTabs && contentTabs[indexTab] && contentTabs[indexTab].data) {
    contentTabs[indexTab].data.forEach(item => {
      if (item.active || item.value) {
        hasValue = true;
      }
    });
  }

  return hasValue;
}

export function checkCanChangeCategory(selectingCategory, selectedCategory) {
  let canChange = false;
  if (selectedCategory.isSkip) {
    canChange = true;
  } else {
    if (CATEGORY_NUMBER[selectedCategory.id] > CATEGORY_NUMBER[selectingCategory.id]) {
      if (checkCanNext(selectingCategory, selectingCategory.indexTab)) {
        canChange = true;
      }
    } else {
      if (selectedCategory.isSelected) {
        canChange = true;
      }
    }
  }
  return canChange;
}

export function setSubTabTitle(selectingCategory) {
  const indexTab = selectingCategory.indexTab || 0;
  const subTabs = selectingCategory.subTabs || [];
  const newSubTab = cloneDeep(subTabs);
  const contentTabs = selectingCategory.contentTabs || [];
  if (subTabs && subTabs.length && contentTabs && contentTabs.length) {
    const selectingContentTabsData = contentTabs && contentTabs[indexTab] && contentTabs[indexTab].data ? contentTabs[indexTab].data : [];
    switch (selectingCategory.id) {
      case CATEGORY_ID.TU1_AGE: {
        const value =
          selectingContentTabsData && selectingContentTabsData[0] && selectingContentTabsData[0].value
            ? selectingContentTabsData[0].value
            : '';
        newSubTab[indexTab].value = moment().diff(moment(value), 'years').toString();
        newSubTab[indexTab].isSelected = true;
        break;
      }
      case CATEGORY_ID.TU2_HEIGHT: {
        const activeItem = selectingContentTabsData.find(x => x.active);
        const label = activeItem && activeItem.label ? activeItem.label : '';
        const id = activeItem ? activeItem.id : '';
        let value = '';
        const tmp = label ? label.split(' ') : [];
        value = tmp && tmp[0] ? tmp[0] : '';
        if (id === 0) {
          value = label;
        }
        if (id === 20 || id === 1) {
          value = tmp && tmp[0] && tmp[1] ? `${tmp[0]} ${tmp[1]}` : '';
        }
        newSubTab[indexTab].value = value;
        newSubTab[indexTab].isSelected = true;
        break;
      }
      case CATEGORY_ID.TU1_ETHNICITY:
      case CATEGORY_ID.TU2_BODY_TYPE:
      case CATEGORY_ID.TU2_ORIENTATION: {
        const activeItem = selectingContentTabsData.find(x => x.active);
        const value = activeItem && activeItem.label ? activeItem.label : '';
        newSubTab[indexTab].value = value;
        newSubTab[indexTab].isSelected = true;
        break;
      }
      default:
        break;
    }
  }
  return newSubTab;
}

export function getIconCategoryItem(categoryId, itemId) {
  try {
    return CATEGORY_ITEM_ICON[categoryId][itemId.toString()];
  } catch (e) {
    console.log('getIconCategoryItem error', e.message);
    return null;
  }
}

export function convertLabelCategory(itemId) {
  try {
    return CATEGORY_LOOKING_FOR_ITEM_LABEL[itemId.toString()];
  } catch (e) {
    console.warn('convertLabelCategory error ', e.message);
    return null;
  }
}

export function collectProfileData(categories) {
  let collectionData = '';
  if (categories && categories.length) {
    categories.forEach(category => {
      const data = category.contentTabs[category.indexTab].data || [];
      const activeItem = data.find(x => x.active);
      if (activeItem && activeItem.label) {
        if (!collectionData) {
          collectionData = activeItem.label;
        } else {
          collectionData += `\n\n${activeItem.label}`;
        }
      }
    });
  }
  return collectionData;
}

export function setDefaultAge(defaultAge) {
  const d = new Date();
  const year = d.getFullYear();
  const month = d.getMonth();
  const day = d.getDate();
  const newDate = new Date(year - defaultAge, month, day);
  return newDate;
}

export function checkShowNextDesktop(categoryId) {
  let isShowNextDesktop = false;
  const categoryNumber = CATEGORY_NUMBER[categoryId];
  if (categoryNumber === 12 || categoryNumber === 13) {
    return true;
  }
  const { userRegister } = getStore().getState();

  if (userRegister && userRegister[categoryId] && checkCanNext(userRegister[categoryId])) {
    isShowNextDesktop = true;
  }

  return isShowNextDesktop;
}

export function hasNumber(myString) {
  return /\d/.test(myString);
}

export function getDateTimeTooltipData(message) {
  let dateTimeData = { date: '', time: '' };
  if (message && message.time) {
    const date = getFormattedDate(message.time, 'MMM DD');
    const time = getFormattedDate(message.time, 'hh:mma');
    dateTimeData = { date, time };
  }
  return dateTimeData;
}

export function checkAllDataLoaded(categories) {
  if (!categories || !categories.length) {
    return false;
  }
  let allDataLoaded = true;
  categories.forEach(cate => {
    const indexTab = cate.indexTab || 0;
    if (
      cate &&
      cate.contentTabs &&
      cate.contentTabs[indexTab] &&
      cate.contentTabs[indexTab].data &&
      cate.contentTabs[indexTab].data.length
    ) {
      allDataLoaded = true;
    }
  });
  return allDataLoaded;
}

export function gUID() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
}

export const sumArrayItem = (sumTotal, currentValue) => sumTotal + currentValue;

export function generateParamsMemberSearch(state) {
  // console.log('here',state)
  const { filters, checkedOrderByType } = state;
  const params = {};
  const entities = {
    ...MEMBER_SEARCH_SCREEN.ENTITIES,
    ...MEMBER_SEARCH_SCREEN.FILTERS_ENTITIES,
    ...MEMBER_SEARCH_SCREEN.FILTER_OTHER_ENTITIES,
  };
  if (filters.userName) {
    return {
      UserName: filters.userName,
      Type: 'Username',
    };
  }
  Object.keys(filters).forEach(key => {
    switch (key) {
      case 'userName':
        if (filters[key] && filters[key] !== '') {
          params.UserName = filters[key];
          params.Type = 'Username';
        }
        break;
      case 'withPhotos':
      case 'minAge':
      case 'maxAge':
      case 'isVerified':
      case 'onlineNow':
      case 'hasValidations':
        params[key.charAt(0).toUpperCase() + key.substr(1)] = filters[key];
        break;
      case 'niche': {
        if (filters[key]) {
          params.Niche = filters[key].value.searchSetting.Niche;
        }
        break;
      }
      case 'orderByType': {
        if (checkedOrderByType.length > 0) {
          if (checkedOrderByType[0].id === MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.NEAR_BY) {
            params.Type = 'Nearby';
            params.OrderByType = '';
            params.SearchGeoPoint = {
              Latitude: state.searchGeoPoint ? state.searchGeoPoint.lat : -1,
              Longitude: state.searchGeoPoint ? state.searchGeoPoint.lng : -1,
            };
          } else {
            params.OrderByType = checkedOrderByType[0].value;
          }
        }
        break;
      }
      case 'location': {
        if ((filters[key] && filters[key].placeId) || (filters[key] && filters[key].GoogleMapPlacesId)) {
          params.GoogleMapPlace = {
            PlacesId: filters[key].placeId ? filters[key].placeId : filters[key].GoogleMapPlacesId,
            Types: filters[key] && filters[key].LocationType ? [filters[key].LocationType] : [],
          };
        }
        break;
      }
      case 'searchRadius': {
        if (
          filters.location &&
          (filters.location.LocationType === 'Suburb' ||
            filters.location.LocationType === 'locality' ||
            filters.location.LocationType === 'administrative_area_level_3')
        ) {
          params[key.charAt(0).toUpperCase() + key.substr(1)] = filters[key];
        }
        break;
      }
      case CATEGORY_ID.MS_MEMBER_TYPE:
        params.MemberType = filters[key];
        break;
      default:
        break;
    }
  });
  Object.entries(entities).forEach((item, index) => {
    const name = item[0];
    if (state[name] && state[name].contentTabs && state[name].contentTabs[0].data) {
      let selectedItems = state[name].contentTabs[0].data.filter(subItem => subItem.active);

      if (selectedItems.length > 0 && selectedItems[0].id !== -1) {
        if (name !== CATEGORY_ID.SEXUAL_INTERESTS) {
          selectedItems = selectedItems.map(subItem => subItem.id);
        }
        switch (name) {
          case CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE:
            params.MemberType = selectedItems.reduce(sumArrayItem);
            break;
          case CATEGORY_ID.LTM_LOOKING_FOR:
            params.SeekingType = selectedItems.reduce(sumArrayItem);
            break;
          case CATEGORY_ID.TU1_ETHNICITY:
            params.Race = selectedItems;
            break;
          case CATEGORY_ID.TU2_BODY_TYPE:
            params.BodyType = selectedItems;
            break;
          case CATEGORY_ID.PARTICIPATION_LEVEL:
            params.Participation = selectedItems;
            break;
          case CATEGORY_ID.SAFE_SEX:
            params.SafeSex = selectedItems;
            break;
          case CATEGORY_ID.MARITAL_STATUS:
            params.MaritalStatus = selectedItems;
            break;
          case CATEGORY_ID.ENDOWMENT:
            params.EndowmentLength = selectedItems;
            break;
          case CATEGORY_ID.TU2_HEIGHT:
            params.Height = selectedItems;
            break;
          case CATEGORY_ID.WYI_SEXUAL:
            params.SexualOrientation = selectedItems;
            break;
          case CATEGORY_ID.SEXUAL_INTERESTS:
            params.SexualIntererest = selectedItems
              .filter(subItem => subItem.listId === 71 || subItem.listId === 72)
              .map(subItem => subItem.id);
            params.SexualPreference = selectedItems.filter(subItem => subItem.listId === 70).map(subItem => subItem.id);
            break;
          case CATEGORY_ID.WYI_FETISH:
            params.FetishInterest = selectedItems;
            break;
          case CATEGORY_ID.LTM_INTENTIONS:
            params.Intention = selectedItems;
            break;
          case CATEGORY_ID.SMOKING:
            params.Smoking = selectedItems;
            break;
          case CATEGORY_ID.CUP_SIZE:
            params.CupSize = selectedItems;
            break;
          case CATEGORY_ID.PUBIC_HAIR:
            params.PubicHair = selectedItems;
            break;
          default:
            break;
        }
      }
    }
  });
  return params;
}

export function generateParamsMemberProspects(state) {
  const { filters } = state;
  const params = {};
  const entities = {
    ...MEMBER_SEARCH_SCREEN.ENTITIES,
  };
  Object.keys(filters).forEach(key => {
    switch (key) {
      case 'pageSize': {
        if (filters[key] && filters[key] !== '') {
          params.Size = filters[key];
        }
        break;
      }
      case 'page': {
        if (filters[key] && filters[key] !== '') {
          params.Page = filters[key];
        }
        break;
      }
      case 'type': {
        if (filters[key] && filters[key] !== '') {
          params.Type = filters[key];
        }
        break;
      }
      case 'minAge': {
        if (filters[key] && filters[key] !== '') {
          params.MinAge = filters[key];
        }
        break;
      }
      case 'maxAge': {
        if (filters[key] && filters[key] !== '') {
          params.MaxAge = filters[key];
        }
        break;
      }
      case 'radius': {
        if (
          filters.location &&
          (filters.location.LocationType === 'Suburb' ||
            filters.location.LocationType === 'locality' ||
            filters.location.LocationType === 'administrative_area_level_3')
        ) {
          if (filters[key] && filters[key] !== '') {
            params.Radius = filters[key];
          }
        }
        break;
      }
      case 'searchRadius': {
        if (
          filters.location &&
          (filters.location.LocationType === 'Suburb' ||
            filters.location.LocationType === 'locality' ||
            filters.location.LocationType === 'administrative_area_level_3')
        ) {
          if (filters[key] && filters[key] !== '') {
            params.Radius = filters[key];
          }
        }
        break;
      }
      case 'location': {
        if ((filters[key] && filters[key].placeId) || (filters[key] && filters[key].GoogleMapPlacesId)) {
          params.GoogleMapPlace = {
            PlacesId: filters[key].placeId ? filters[key].placeId : filters[key].GoogleMapPlacesId,
            Types: filters[key].LocationType ? [filters[key].LocationType] : [],
          };
        }
        break;
      }
      // this one for memberprospec likes and matches
      case 'listType': {
        if (filters[key] && filters[key] !== '') {
          params.ListType = filters[key];
        }
        break;
      }
      case 'isFavourite': {
        if (filters[key] && filters[key] !== '') {
          params.IsFavourite = filters[key];
        }
        break;
      }
      case 'showMeMemberType': {
        let selectedItems = filters[key].contentTabs[0].data.filter(subItem => subItem.active);
        selectedItems = selectedItems.map(subItem => subItem.id);
        if (selectedItems.length > 0 && selectedItems[0].id !== -1) {
          params.MemberType = selectedItems.reduce(sumArrayItem);
        }
        break;
      }
      case 'matchingMember': {
        params.Match = filters[key];
        break;
      }
      default:
        break;
    }
  });

  return params;
}

export function generateParamsNicheSearch(nicheSetting) {
  const params = {
    MaxAge: nicheSetting.AgeMax,
    MinAge: nicheSetting.AgeMin,
    Niche: nicheSetting.Niche,
    CountryID: nicheSetting.Location.CountryID,
    PostCodeAllID: nicheSetting.Location.PostCodeAllID,
    StateID: nicheSetting.Location.StateID,
    MemberType: nicheSetting.MemberType,
    GoogleMapPlace: {
      PlacesId: nicheSetting.Location.GoogleMapPlacesId,
      Types: ['regions'],
    },
    IsVerified: nicheSetting.IsVerified,
    OnlineNow: nicheSetting.OnlineNow,
    SearchRadius: nicheSetting.SearchRadius,
    OrderByType: nicheSetting.OrderByType,
    WithPhotos: nicheSetting.WithPhotos,
    HasValidations: nicheSetting.HasValidations,
    SeekingType: nicheSetting.SeekingMemberType,
    Type: nicheSetting.ProfileSearchType,
  };
  return params;
}

export function extractDateToUnix(dateString) {
  // console.log("convert date string", dateString.match(/(?:Date\()(.*)(?:-0000|.+0800)/))
  return dateString ? dateString.match(/(?:Date\()(.*)(?:-0000|\+0800)/)[1] : 0;
}

export function generateParams(params) {
  const updateParams = {};
  if (params.pageSize) {
    updateParams.Size = params.pageSize;
  }
  if (params.pageNumber || params.page) {
    updateParams.Page = params.pageNumber || params.page;
  }
  if (params.recipientUserId) {
    updateParams.RecipientUserID = params.recipientUserId;
  }
  return updateParams;
}

export function capitalizeFirstWord(str) {
  return str.replace(/\w\S*/g, txt => {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export function isValidSwipe(velocity, velocityThreshold, directionalOffset, directionalOffsetThreshold) {
  return Math.abs(velocity) >= velocityThreshold && Math.abs(directionalOffset) < directionalOffsetThreshold;
}

export function checkRightClick(ev) {
  if (BROWSER_CLICK.RIGHT_IE in ev) {
    return ev.button === BROWSER_CLICK.RIGHT_IE_CODE_MOUSE_RIGHT;
  } else if (BROWSER_CLICK.RIGHT_OTH in ev) {
    return ev.which === BROWSER_CLICK.RIGHT_OTH_CODE_MOUSE_RIGHT;
  }
  return false;
}

export function getTimeImageWillBeExpired(expiredTime) {
  const days = moment(expiredTime).diff(moment(), 'days', false);
  if (days > 1) {
    return `${days} days`;
  }
  const hours = Math.ceil(moment(expiredTime).diff(moment(), 'hour', true));
  if (hours > 24) {
    return `1 day`;
  }
  return `${hours} hours`;
}

export function mappingSelectedUserSetting(defaultValue, selectedItems = [], items) {
  const result = [];
  if (defaultValue) {
    const powArr = decimalToBinary(defaultValue);
    items.forEach((item, index) => {
      const idx = powArr ? powArr.indexOf(item.id) : -1;
      if (idx !== -1) {
        result.push(index);
      }
    });
  }
  return result;
}

export function getTimeChat(userSent, buddySent, showFull) {
  // return 6;
  const days = moment(buddySent).add(7, 'days').diff(moment(), 'days', true);
  const hours = moment(buddySent).add(7, 'days').diff(moment(), 'hours', true);
  const min = moment(buddySent).add(7, 'days').diff(moment(), 'minutes', true);
  const data = ['h', 'm', 'd'];
  if (buddySent && buddySent - userSent > 0) {
    if (days < 1 && hours >= 1) {
      return Math.round(hours) + data[0];
    } else if (days < 1 && hours < 1 && min >= 1) {
      return Math.round(min) + data[1];
    } else if (days < 1 && hours < 1 && min < 1) {
      return null;
    }
    if (showFull) {
      return `${Math.round(days)} days`;
    }
    return Math.round(days) + data[2];
  }
  return null;
}

export function checkDiffConversation(data, preData) {
  let isCheck = false;
  let i = 0;
  const lengthData = data.length;
  const lengthPreData = preData.length;
  if (lengthData !== lengthPreData) {
    isCheck = true;
    return isCheck;
  }
  for (i = 0; i < lengthPreData; i++) {
    if (
      data[i].timestamp !== preData[i].timestamp ||
      data[i].message.createdAt !== preData[i].message.createdAt ||
      data[i].message.time !== preData[i].message.time ||
      data[i].pinned !== preData[i].pinned ||
      data[i].unreadCount !== preData[i].unreadCount ||
      data[i].message.isDelete !== preData[i].message.isDelete ||
      data[i].lastBuddySentTime !== preData[i].lastBuddySentTime ||
      data[i].lastUserSentTime !== preData[i].lastUserSentTime ||
      data[i].folders.length !== preData[i].folders.length ||
      data[i].message.read !== preData[i].message.read ||
      data[i].message.expts !== preData[i].message.expts
    ) {
      isCheck = true;
      break;
    }
  }
  return isCheck;
}

export function arraysEqual(a, b) {
  if (a === b) {
    return true;
  }
  // eslint-disable-next-line eqeqeq
  if ((a == null && b != null) || (a != null && b == null)) {
    return false;
  }
  // eslint-disable-next-line eqeqeq
  if (a == null && b == null) {
    return true;
  }
  if (a.length !== b.length) {
    return false;
  }

  for (let i = 0; i < a.length; ++i) {
    if (!deepEqual(a[i], b[i])) {
      return false;
    }
  }
  return true;
}

export function arraysShallowEqual(a, b) {
  if (a === b) {
    return true;
  }
  // eslint-disable-next-line eqeqeq
  if ((a == null && b != null) || (a != null && b == null)) {
    return false;
  }
  // eslint-disable-next-line eqeqeq
  if (a == null && b == null) {
    return true;
  }
  if (a.length !== b.length) {
    return false;
  }

  for (let i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) {
      return false;
    }
  }
  return true;
}

export function deepEqual(x, y) {
  if (x === y) {
    return true;
  } else if (typeof x === 'object' && x !== null && typeof y === 'object' && y !== null) {
    if (Object.keys(x).length !== Object.keys(y).length) {
      return false;
    }
    let res = true;
    Object.keys(x).forEach(prop => {
      // eslint-disable-next-line no-prototype-builtins
      if (y.hasOwnProperty(prop)) {
        if (!deepEqual(x[prop], y[prop])) {
          res = false;
        }
      }
    });

    return res;
  }
  return false;
}

export function arrayMove(arr, oldIndex, newIndex) {
  if (newIndex >= arr.length) {
    let k = newIndex - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
  return arr; // for testing
}

export function getSexUser(str) {
  const newStr = str.substring(1);
  switch (str.charAt(0)) {
    case 'M':
      return `Male ${newStr}`;
    case 'F':
      return `Female ${newStr}`;
    case 'G':
      return `Group ${newStr}`;
    case 'TW':
      return `Trans Women ${newStr}`;
    case 'TM':
      return `Trans Men ${newStr}`;
    case 'T':
      return `TV/CD ${newStr}`;
    default:
      return null;
  }
}

/**
 *  Function detect broser type
 *
 *  @returns {BROWSER_TYPES}
 */
export function detectBrowser() {
  const { userAgent } = window.navigator;
  const chrome = /.*(Chrome\/).*(Safari\/).*/g;
  const firefox = /.*(Firefox\/).*/g;
  const safari = /.*(Version\/).*(Safari\/).*/g;
  const opera = /.*(Chrome\/).*(Safari\/).*(OPR\/).*/g;
  const edge = /.*(Chrome\/).*(Safari\/).*(Edge\/).*/g;
  const ie = /.*(Trident\/7).*(rv:).*/g;

  if (opera.exec(userAgent)) {
    return OPERA;
  }
  if (edge.exec(userAgent)) {
    return EDGE;
  }
  if (chrome.exec(userAgent)) {
    return CHROME;
  }
  if (safari.exec(userAgent)) {
    return SAFARI;
  }
  if (firefox.exec(userAgent)) {
    return FIREFOX;
  }
  if (ie.exec(userAgent)) {
    return IE;
  }
  if (userAgent.match('CriOS')) {
    return CHROME_IOS;
  }
  if (userAgent.match('FxiOS')) {
    return FIREFOX_IOS;
  }
  return null;
}

/**
 * Function detect is IOS,
 * return true: is IOS
 * return false: is not IOS
 * @returns {boolean}
 */
export function detectIos() {
  return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
}

export function convertReversalTime(timestamp) {
  moment.updateLocale('en', {
    relativeTime: {
      ...MOMENT_RELATIVE_TIME,
    },
  });
  return moment(moment.unix(timestamp / 1000).format('YYYYMMDDkkmmss'), 'YYYYMMDDkkmmss').fromNow(true);
}

export function convertDateFinderTravel(timestamp) {
  const dataTime = moment(timestamp, 'x');

  return `${dataTime.format('ddd').toUpperCase()} ${dataTime.format('DD')} ${dataTime.format('MMM').toUpperCase()}`;
}

/**
 * Function detect error get media device
 *
 * Param: error, type DOMException
 *
 * Return: Message, type string
 */
export function detectErrorGetMediaDevice(error) {
  let resultString = '';
  switch (error.name) {
    case NOT_ALLOW_ERROR:
    case SECURITY_ERROR:
    case NOT_READ_ABLE_ERROR: {
      resultString = 'ChatRoomsScreen.WarningAccessCamera';
      break;
    }
    // case NOT_FOUND_ERROR:
    // case ABORT_ERROR:
    // case OVER_CONSTRAINED_ERROR:
    default:
      break;
  }
  return resultString;
}

export function removeSpace(str) {
  if (str) {
    return str.replace(/\s+/g, '');
  }
  return str;
}

export function filterIdStream(str) {
  if (str) {
    return str.replace(/[^\d]/g, '');
  }
  return str;
}

export function filterRoomDisplayName(str) {
  if (str) {
    return str.replace(/[0-9]+/g, '');
  }
  return str;
}

export function groupStreamInEachRoom(arrStream) {
  const groupToValues = arrStream.reduce((obj, item) => {
    obj[item.roomDisplayName] = obj[item.roomDisplayName] || [];
    obj[item.roomDisplayName].push(item.streamName);
    return obj;
  }, {});
  const groups = Object.keys(groupToValues).map(key => {
    return { roomDisplayName: key, streamNames: groupToValues[key] };
  });
  return groups;
}

export function removeDuplicates(myArr, prop) {
  return myArr.filter((obj, pos, arr) => {
    return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
  });
}

export function checkEmptyObj(obj) {
  let res = true;
  Object.keys(obj).forEach(() => {
    res = false; // not Empty
  });
  return res; // empty
}

export function addDestinationAlertNotification(typeId) {
  try {
    return TYPE_ALERT_DESTINATION[typeId.toString()];
  } catch (e) {
    console.warn('addDestinationAlertNotification error ', e.message);
    return null;
  }
}

export function getDaysArray(year, month) {
  if (!year && !month) {
    // eslint-disable-next-line no-param-reassign
    year = parseInt(moment().format('YYYY'));
    // eslint-disable-next-line no-param-reassign
    month = parseInt(moment().format('MM'));
  }
  const names = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  const date = new Date(year, month - 1, 1);
  const result = [];
  while (date.getMonth() === month - 1) {
    const data = {
      dayOfMonth: date.getDate(),
      dayOfWeek: names[date.getDay()],
    };
    result.push(data);
    date.setDate(date.getDate() + 1);
  }
  return result;
}

export function getDateAfterNumberOfMonth(date, numberOfMonth = 1) {
  if (!date) {
    // eslint-disable-next-line no-param-reassign
    date = new Date();
  }
  const newDate = new Date(date.setMonth(date.getMonth() + numberOfMonth));
  return newDate;
}

export function getDatesBetweenTwoDate(startDate, finishDate) {
  const dateArray = [];
  let currentDate = startDate;
  const DAYS = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  while (currentDate <= finishDate) {
    const data = {
      dayOfMonth: currentDate.getDate(),
      dayOfWeek: DAYS[currentDate.getDay()],
      month: convertNumberToMonthFormat(currentDate.getMonth() + 1),
      date: currentDate,
    };
    dateArray.push(data);
    currentDate = currentDate.addDays(1);
  }
  return dateArray;
}

export function getRandomNumber(min, max) {
  return Math.random() * (max - min) + min;
}

export const toTimestamp = strDate => {
  // eslint-disable-next-line no-extend-native
  Date.prototype.getUnixTime = function () {
    return this.getTime() / 1000 || 0;
  };
  if (!Date.now) {
    Date.now = function () {
      return new Date();
    };
  }
  Date.time = function () {
    return Date.now().getUnixTime();
  };
  const parsed = new Date(strDate).getUnixTime();
  return parsed;
};

export function generateParamsCreateEvent(data) {
  let GuestTypes = 0;
  let selectedItems = data.showMeMemberType.contentTabs[0].data.filter(subItem => subItem.active);
  selectedItems = selectedItems.map(subItem => subItem.id);
  if (selectedItems.length > 0 && selectedItems[0].id !== -1) {
    GuestTypes = selectedItems.reduce(sumArrayItem);
  }
  // format Mar 24, 2019 10:24 AM // moment().format('lll');
  // console.log(data);
  const params = {
    EventID: data.eventId ? data.eventId : 0,
    EventTitle: data.title,
    GoogleMapPlaceID: data.location.GoogleMapPlacesId,
    LocationLabel: data.location.StateName,
    GuestTypes,
    AgeRange: {
      AgeFrom: data.minAge,
      AgeTo: data.maxAge,
    },
    Description: data.description,
    Theme: data.theme,
    DressCode: data.dressCode,
    Rules: data.rules,
    Cost: data.entryFee,
    TicketUrl: data.ticketUrl,
    IsTicketPrivate: data.isTicketUrlPrivate || false,
    Phone: data.phone,
    Email: data.email,
    Website: data.website,
    DateHeld: data.dateHeld,
    ApprovalStatus: data.approvalStatus ? data.approvalStatus : 'Pending',
    Banner: data.banner
      ? {
          FileName: data.banner.fileName,
          BannerUrl: data.banner.bannerUrl,
        }
      : null,
    VideoUrl: data.videoUrl || '',
    IsSponsored: data.isSponsored || false,
    IsFeatured: data.isFeatured || false,
    TicketUrl: data.ticketUrl || '',
    Categories: data.categories?.map(i => eventDetail.mappingCategoryToDTO(i)) || [],
  };
  if (data.timezoneItem) {
    params.TimeZoneInfoID = data.timezoneItem.id;
    params.TimeZone = {
      ID: data.timezoneItem.id,
      WindowsName: data.timezoneItem.windowsName,
      StandardName: data.timezoneItem.standardName,
      DaylightName: data.timezoneItem.daylightName,
      SupportsDaylightSavingTime: data.timezoneItem.supportsDaylightSavingTime,
      IsDaylightSavingTime: data.timezoneItem.isDaylightSavingTime,
      IanaName: data.timezoneItem.ianaName,
      AbbrGeneric: data.timezoneItem.abbrGeneric,
      AbbrStandard: data.timezoneItem.abbrStandard,
      AbbrDaylight: data.timezoneItem.abbrDaylight,
      BaseUtcOffset: data.timezoneItem.baseUtcOffset,
      DaylightOffset: data.timezoneItem.daylightOffset,
    };
  }

  if (data.mailOutBanner !== null) {
    params.MailOutBanner = data.mailOutBanner;
  }
  //  console.log(params);
  return params;
}

export function generateParamsClubSearch(data) {
  const params = {
    // StateID: data && data.stateId ? data.stateId : -1,
    // CountryID: data && data.countryId ? data.countryId : -1,
    CategoryID: data && data.categoryId ? data.categoryId : -1,
    Page: data && data.page ? data.page : 1,
    Size: data && data.pageSize ? data.pageSize : 20,
    GoogleMapPlaceID: data && data.location ? data.location.GoogleMapPlacesId : '',
  };
  return params;
}

export function generateParamsEventSearch(data) {
  let params = {
    CategoryID: data && data.categoryId ? data.categoryId : -1,
    DateStart: data && data.dateStart ? data.dateStart : '',
    DateEnd: data && data.dateEnd ? data.dateEnd : '',
    GoogleMapPlaceID: data && data.location ? data.location.GoogleMapPlacesId : '',
    FeaturedType: data && data.featuredType ? data.featuredType : 'All',
    InterestedOnly: (data && data.isInterestedOnly) || false,
    // Page: data && data.page ? data.page : 1,
    // Size: data && data.pageSize ? data.pageSize : 24
  };
  if (
    data &&
    data.location &&
    (data.location.LocationType === 'Suburb' ||
      data.location.LocationType === 'locality' ||
      data.location.LocationType === 'administrative_area_level_3')
  ) {
    params.Radius = data && data.searchRadius ? data.searchRadius : 100;
  }
  if (data && data.sponsoredType) {
    params.SponsoredType = data.sponsoredType;
  }
  if (data.searchTerm?.length > 0) {
    if (data.isDesktop) {
      params.SearchTerm = data.searchTerm;
    } else {
      params = {
        SearchTerm: data.searchTerm,
      };
    }
  }
  // console.log(params)
  return params;
}

export function generateParamsDateFinder(data) {
  const params = {};
  if (data) {
    if (!!data.ageMin) {
      params.AgeMin = data.ageMin;
    }
    if (!!data.ageMax) {
      params.AgeMax = data.ageMax;
    }
    if ((!!data.location && data.location.googleMapPlacesId) || (!!data.location && data.location.GoogleMapPlacesId)) {
      params.GoogleMapPlaceID = data.location.googleMapPlacesId || data.location.GoogleMapPlacesId;
    }
    if (
      !!data.searchRadius &&
      data.location &&
      (data.location.LocationType === 'Suburb' ||
        data.location.LocationType === 'locality' ||
        data.location.LocationType === 'administrative_area_level_3')
    ) {
      params.SearchRadius = data.searchRadius;
    }
    if (!!data.startDate) {
      params.StartDate = data.startDate;
    }
    if (!!data.endDate) {
      params.EndDate = data.endDate;
    }
    if (!!data.customDate) {
      params.CustomDate = data.customDate;
    }
    if (
      !!data.showMeMemberType &&
      data.showMeMemberType.contentTabs &&
      data.showMeMemberType.contentTabs[0] &&
      data.showMeMemberType.contentTabs[0].data
    ) {
      let selectedItems = data.showMeMemberType.contentTabs[0].data.filter(subItem => subItem.active);
      selectedItems = selectedItems.map(subItem => subItem.id);
      if (selectedItems.length > 0) {
        params.SeekingTypes = selectedItems.reduce(sumArrayItem);
      }
    }
    params.WithPhoto = data.withPhoto;
    if (!!data.arrMeetingType) {
      let selectedItems = data.arrMeetingType.filter(subItem => subItem.active);
      selectedItems = selectedItems.map(subItem => subItem.id);
      if (selectedItems.length > 0) {
        params.MeetingTypes = selectedItems.reduce(sumArrayItem);
      }
    }
  }
  return {
    SearchCriteria: {
      ...params,
    },
    Size: (data && data.size) || 50,
    Page: (data && data.page) || 1,
  };
}

export function generateParamsTravelPlan(data) {
  const params = {
    Page: 1,
    Size: PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
  };
  if (data) {
    if (!!data.ageMin) {
      params.MinAge = data.ageMin;
    }
    if (!!data.ageMax) {
      params.MaxAge = data.ageMax;
    }
    if ((!!data.location && data.location.googleMapPlacesId) || (!!data.location && data.location.GoogleMapPlacesId)) {
      params.GoogleMapPlace = {
        PlacesId: data.location.googleMapPlacesId || data.location.GoogleMapPlacesId,
        Types: data.location.locationType ? data.location.locationType : '',
      };
    }
    if (
      !!data.searchRadius &&
      data.location &&
      (data.location.LocationType === 'Suburb' ||
        data.location.LocationType === 'locality' ||
        data.location.LocationType === 'administrative_area_level_3')
    ) {
      params.SearchRadius = data.searchRadius;
    }
    if (!!data.page) {
      params.Page = data.page;
    }
    if (!!data.size) {
      params.Size = data.size;
    }
    if (
      !!data.showMeMemberType &&
      data.showMeMemberType.contentTabs &&
      data.showMeMemberType.contentTabs[0] &&
      data.showMeMemberType.contentTabs[0].data
    ) {
      let selectedItems = data.showMeMemberType.contentTabs[0].data.filter(subItem => subItem.active);
      selectedItems = selectedItems.map(subItem => subItem.id);
      if (selectedItems.length > 0) {
        params.MemberType = selectedItems.reduce(sumArrayItem);
      }
    }
  }
  return params;
}

export function getdayInThisWeek() {
  //  let startOfWeek = moment().add(1,"week").startOf('isoWeek'); nextWEEK
  //  let endOfWeek = moment().add(1,"week").endOf('isoWeek'); nextWEEK
  //  let startOfWeek = moment().startOf('isoWeek');
  const startOfWeek = moment();
  const endOfWeek = moment().endOf('isoWeek');
  const days = [];
  let day = startOfWeek;

  while (day <= endOfWeek) {
    days.push(parseInt(moment(day.toDate()).format('DD')));
    day = day.clone().add(1, 'd');
  }
  return days;
}

export function sortDataSearch(dataSort, isUnix) {
  if (dataSort) {
    if (isUnix) {
      // eslint-disable-next-line no-param-reassign
      dataSort = groupBy(dataSort, d => moment(d.dateHeld, 'x').format('YYYY'));
    } else {
      // eslint-disable-next-line no-param-reassign
      dataSort = groupBy(dataSort, d => moment(extractDateToUnix(d.searchItem?.dateHeld), 'x').format('YYYY'));
    }
    // eslint-disable-next-line no-param-reassign
    dataSort = reduce(
      dataSort,
      (acc, next, index) => {
        const res = sortDataWithMonth(next, isUnix, index);
        // eslint-disable-next-line no-param-reassign
        acc = [...acc, ...res];

        return acc;
      },
      []
    );
  }
  return dataSort;
}

function sortDataWithMonth(dataSort, isUnix, year) {
  const dataSortThisWeek = [];
  const dataSortNextWeek = [];
  if (dataSort) {
    if (isUnix) {
      // eslint-disable-next-line no-param-reassign
      dataSort = groupBy(dataSort, d => moment(d.dateHeld, 'x').format('MMMM'));
    } else {
      // eslint-disable-next-line no-param-reassign
      dataSort = groupBy(dataSort, d => moment(extractDateToUnix(d.searchItem?.dateHeld), 'x').format('MMMM'));
    }
    // eslint-disable-next-line no-param-reassign
    dataSort = reduce(
      dataSort,
      (acc, next, index) => {
        if (index === moment().format('MMMM') && year === moment().format('YYYY')) {
          next.forEach(item => {
            if (isUnix) {
              if (
                getdayInThisWeek().indexOf(parseInt(moment(item.dateHeld, 'x').format('DD'))) > -1 ||
                parseInt(moment(item.dateHeld, 'x').format('DD')) < moment().format('DD')
              ) {
                dataSortThisWeek.push(item);
              } else {
                dataSortNextWeek.push(item);
              }
            } else {
              if (
                getdayInThisWeek().indexOf(parseInt(moment(extractDateToUnix(item.searchItem.dateHeld), 'x').format('DD'))) > -1 ||
                moment(extractDateToUnix(item.searchItem.dateHeld), 'x').format('DD') < moment().format('DD')
              ) {
                dataSortThisWeek.push(item);
              } else {
                dataSortNextWeek.push(item);
              }
            }
          });
          if (dataSortThisWeek.length > 0) {
            acc.push({
              year,
              title: `This week - ${year}`,
              titleString: 'This week',
              data: dataSortThisWeek,
            });
          }
          if (dataSortNextWeek.length > 0) {
            acc.push({
              year,
              title: `Next week - ${year}`,
              titleString: 'Next week',
              data: dataSortNextWeek,
            });
          }
        } else {
          acc.push({
            year,
            title: `${index} - ${year}`,
            titleString: index,
            data: next,
          });
        }
        return acc;
      },
      []
    );
  }

  return dataSort;
}

export function genereateParamsPostCommentReply(data) {
  const params = {
    ID: data && data.id ? data.id : null,
    CommentParentID: data && data.commentParentID ? data.commentParentID : null,
    Subject: '', // data && data.id ? data.id : '',
    Message: data && data.message ? data.message.toString() : '',
    MessageContentType: data.contentType || COMMENT_MESSAGE_CONTENT_TYPE.TEXT,
  };
  return params;
}

export function generateLiveStreamName() {
  return Math.random().toString(36).substring(7);
}

export function getUserNameFromPublicLiveStream(string) {
  return string && string.substring(string.indexOf('-') + 1);
}

export function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1); // deg2rad below
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in km
  return d;
}

export function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

export function filterConversationsByFolder(conversations, folder, searchCriteria = {}) {
  if (!folder.id) {
    return conversations;
  }
  if (!conversations || !folder || conversations.length === 0) {
    return [];
  }
  const conversationInFolder = conversations.filter(conversation => {
    if (conversation.isGroup) {
      return !conversation.isDelete && conversation.folders.indexOf(folder.id) !== -1;
    }
    return conversation.folders.indexOf(folder.id) !== -1;
  });
  return searchConversations(searchCriteria.keyword, searchCriteria.secondaryIndex, conversationInFolder, [], true);
}

export function upgradeAccountNow(isMobile, params) {
  const index = params && params.index;
  const callbackPaySuccess = params && params.callbackPaySuccess;
  const store = getStore();
  const { paymentGatewayReducer } = store.getState();
  if (paymentGatewayReducer && paymentGatewayReducer.upgradePath === UPGRADE_PATH_TYPE.NONE) {
    store.dispatch(
      commonStateActions.onShowConfirmModal({
        headerText: 'Feature not available',
        messageConfirm: 'This feature is not available with your current subscription level',
        okText: 'OK, got it',
        classNames: 'block-modal',
        disableCancel: true,
      })
    );
  } else if (paymentGatewayReducer && paymentGatewayReducer.upgradePath === UPGRADE_PATH_TYPE.EXTRAS) {
    let urlUpgrade = DEEP_LINKING_APP_UPGRADE_EXTRAS;
    switch (index) {
      case PAYMENT_GATEWAY.PHOTO_INDEX.PARTY_LIKE:
      case PAYMENT_GATEWAY.PHOTO_INDEX.EVENT:
        urlUpgrade += `/${UPGRADE_TYPE.EVENT}`;
        break;
      case PAYMENT_GATEWAY.PHOTO_INDEX.MATCH_WITH_YOU:
      case PAYMENT_GATEWAY.PHOTO_INDEX.DEFAULT:
      case PAYMENT_GATEWAY.PHOTO_INDEX.SEE_WHO_LIKE_USE:
        urlUpgrade += `/${UPGRADE_TYPE.MATCHES}`;
        break;
      case PAYMENT_GATEWAY.PHOTO_INDEX.PHONE_NUMBER:
        urlUpgrade += `/${UPGRADE_TYPE.PHONE}`;
        break;
      case PAYMENT_GATEWAY.PHOTO_INDEX.VIDEO_CALL_LIVE:
        urlUpgrade += `/${UPGRADE_TYPE.VIDEO_CALL}`;
        break;
      case PAYMENT_GATEWAY.PHOTO_INDEX.RESTRICTED_PHOTO:
        urlUpgrade += `/${UPGRADE_TYPE.RESTRICTED}`;
        break;
      default:
        urlUpgrade += '';
    }
    openDeepLinkingApp(urlUpgrade);
  } else {
    let typeUpgrade = MEMBER_TYPES.PREMIUM_PLUS;
    if (paymentGatewayReducer && paymentGatewayReducer.upgradePath) {
      switch (paymentGatewayReducer.upgradePath) {
        case UPGRADE_PATH_TYPE.PLATINUM:
          typeUpgrade = MEMBER_TYPES.PLATINUM;
          break;
        case UPGRADE_PATH_TYPE.DIAMOND:
          typeUpgrade = MEMBER_TYPES.PLATINUM_DIAMOND;
          break;
        default:
          break;
      }
    }
    store.dispatch(
      commonStateActions.updateCommonStateReducerSuccess({
        isShowModalUpgradeMember: true,
        idSlideUpgrade: index !== undefined && index !== null ? index : 2,
        idTypeUpgrade: typeUpgrade,
        callbackPaySuccess,
      })
    );
  }
}

export function upgradeAccountInfo(params) {
  const callbackPaySuccess = params && params.callbackPaySuccess;
  const store = getStore();
  const { paymentGatewayReducer } = store.getState();
  if (paymentGatewayReducer && paymentGatewayReducer.upgradePath === UPGRADE_PATH_TYPE.NONE) {
    handleShowConfirmModal({
      headerText: 'Feature not available',
      messageConfirm: 'This feature is not available with your current subscription level',
      okText: 'OK, got it',
      className: STYLE_MODAL.BLOCK_MODAL,
      disableCancel: true,
    });
  } else if (paymentGatewayReducer && paymentGatewayReducer.upgradePath === UPGRADE_PATH_TYPE.EXTRAS) {
    openDeepLinkingApp(DEEP_LINKING_APP_UPGRADE_EXTRAS);
  } else {
    let typeUpgrade = MEMBER_TYPES.PREMIUM_PLUS;
    if (paymentGatewayReducer && paymentGatewayReducer.upgradePath) {
      switch (paymentGatewayReducer.upgradePath) {
        case UPGRADE_PATH_TYPE.PLATINUM:
          typeUpgrade = UPGRADE_MEMBER_SHIP_ID.PLATINUM;
          break;
        case UPGRADE_PATH_TYPE.DIAMOND:
          typeUpgrade = UPGRADE_MEMBER_SHIP_ID.DIAMOND;
          break;
        default:
          break;
      }
    }
    store.dispatch(
      commonStateActions.updateCommonStateReducerSuccess({
        isShowModalUpgradeInfo: true,
        isUpgradeInfo: true,
        indexTypeUpgrade: typeUpgrade,
        callbackPaySuccess,
      })
    );
  }
}

export function isHaveEmoji(str) {
  // eslint-disable-next-line array-bracket-newline
  const ranges = [
    `(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])`,
    // eslint-disable-next-line array-bracket-newline
  ];
  return str?.match?.(ranges.join('|'));
}

export function isOnlyEmoji(str) {
  try {
    const emojiRe =
      /(?:[\ude80-\udeff\udc00-\ude4f\udf00-\udfff\u00A9\u00AE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9-\u21AA\u231A-\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA-\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614-\u2615\u2618\u261D\u2620\u2622-\u2623\u2626\u262A\u262E-\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u2660\u2663\u2665-\u2666\u2668\u267B\u267F\u2692-\u2697\u2699\u269B-\u269C\u26A0-\u26A1\u26AA-\u26AB\u26B0-\u26B1\u26BD-\u26BE\u26C4-\u26C5\u26C8\u26CE-\u26CF\u26D1\u26D3-\u26D4\u26E9-\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733-\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934-\u2935\u2B05-\u2B07\u2B1B-\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|(?:\uD83C[\uDC04\uDCCF\uDD70-\uDD71\uDD7E-\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01-\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50-\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96-\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F-\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95-\uDD96\uDDA4-\uDDA5\uDDA8\uDDB1-\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB-\uDEEC\uDEF0\uDEF3-\uDEF6]|\uD83E[\uDD10-\uDD1E\uDD20-\uDD27\uDD30\uDD33-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4B\uDD50-\uDD5E\uDD80-\uDD91\uDDC0]))/g;
    // eslint-disable-next-line no-useless-escape
    const textRe = /(?:[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~@:,?'".,\]\[€£¥₫¿¡》《¤▪☆♧♡♡♤■□●○•°\><\\-])/gim;
    // eslint-disable-next-line no-useless-escape
    const spaceRex = /(?:[\ ])/gim;
    const isEmoji = str ? str?.match?.(emojiRe) : false;
    const isText = str ? str?.match?.(textRe) : false;
    const isSpace = str ? str?.match?.(spaceRex) : false;
    if (isEmoji && isEmoji.length > 0 && isText === null) {
      return true;
    }
    return isText === null && str.length > 0 && str.length > isSpace.length;
  } catch (e) {
    return false;
  }
}

export function checkOnlyEmoji(text, type, isDelete) {
  // reSearch : Simple function that returns true if your string contains one or more emojis.
  if (type === messageTypes.TYPE_TEXT && !isDelete) {
    return {
      isHaveEmoji: isHaveEmoji(text),
      isOnlyEmoji: isOnlyEmoji(text),
    };
  }
  return undefined;
}

// Default sort is desc
export function sortQuickMessage(quickMessages, isAsc) {
  if (quickMessages && quickMessages.length > 0) {
    const result = quickMessages.sort((a, b) => {
      return isAsc ? a.templateId - b.templateId : b.templateId - a.templateId;
    });
    return result;
  }
  return [];
}

function retry(isDone, next) {
  let currentTrial = 0;
  const maRetry = 50;
  let isTimeout = false;
  const id = window.setInterval(() => {
    if (isDone()) {
      window.clearInterval(id);
      next(isTimeout);
    }
    if (currentTrial++ > maRetry) {
      window.clearInterval(id);
      isTimeout = true;
      next(isTimeout);
    }
  }, 10);
}

function isIE10OrLater(userAgent) {
  const ua = userAgent.toLowerCase();
  if (ua.indexOf('msie') === 0 && ua.indexOf('trident') === 0) {
    return false;
  }
  const match = /(?:msie|rv:)\s?([\d\.]+)/.exec(ua);
  // eslint-disable-next-line radix
  return match && parseInt(match[1], 10) >= 10;
}

export function detectPrivateMode(callback) {
  let isPrivate;

  if (window.webkitRequestFileSystem) {
    // console.log("CHROME");
    window.webkitRequestFileSystem(
      window.TEMPORARY,
      1,
      () => {
        isPrivate = false;
      },
      e => {
        console.log(e);
        isPrivate = true;
      }
    );
  } else if (window.indexedDB && /Firefox/.test(window.navigator.userAgent)) {
    // console.log("Firefox");
    let db;
    try {
      db = window.indexedDB.open('test');
    } catch (e) {
      isPrivate = true;
    }

    if (typeof isPrivate === 'undefined') {
      retry(
        () => {
          return db.readyState === 'done';
        },
        // eslint-disable-next-line camelcase
        is_timeout => {
          // eslint-disable-next-line camelcase
          if (!is_timeout) {
            isPrivate = !db.result;
          }
        }
      );
    }
  } else if (isIE10OrLater(window.navigator.userAgent)) {
    // console.log("IE");
    isPrivate = false;
    try {
      if (!window.indexedDB) {
        isPrivate = true;
      }
    } catch (e) {
      isPrivate = true;
    }
  } else if (window.localStorage && /Safari/.test(window.navigator.userAgent)) {
    // console.log("Safari");
    if (window.safariIncognito) {
      isPrivate = true;
    } else {
      try {
        window.localStorage.setItem('test', 1);
        window.openDatabase(null, null, null, null);
      } catch (e) {
        isPrivate = true;
      }
    }
    if (typeof isPrivate === 'undefined') {
      isPrivate = false;
      window.localStorage.removeItem('test');
    }
  }

  retry(
    () => {
      return typeof isPrivate !== 'undefined';
    },
    () => {
      callback(isPrivate);
    }
  );
}

export function gotoLinkRHP(url, token = '', target = TYPE_OPEN_URL.CURRENT_TAB, disableAddUnRead = false) {
  // let currentUrl = url === "/" ? ROOT_FOLDER + "/" : window.location.origin + url;
  let currentUrl = window.location.origin + url;
  const store = getStore();
  const { notificationSummaryReducer, loginReducer, conversationsReducer } = store.getState();
  let unReadNotification = 0;
  let unReadProspect = 0;
  let unReadMessenger = 0;
  if (notificationSummaryReducer) {
    unReadNotification = (notificationSummaryReducer.newFeed && notificationSummaryReducer.newFeed.totalNotificationCount) || 0;
    if (notificationSummaryReducer.prospects) {
      const { newFavourites, newMatches, newViews, newLikes } = notificationSummaryReducer.prospects;
      unReadProspect = newFavourites + newMatches + newViews + newLikes;
    }
  }
  if (loginReducer && loginReducer.userInfo && conversationsReducer) {
    unReadMessenger =
      loginReducer.userInfo.messenger.defaultFolder === DEFAULT_FOLDER_OPTION.ALL
        ? conversationsReducer.unreadConversations
        : conversationsReducer.unreadMatchingConversations;
  }

  if (token) {
    currentUrl = currentUrl.replace('{Token}', token);
  }
  if (!disableAddUnRead) {
    if (url && url.split('?').length >= 2) {
      currentUrl += `&`;
    } else {
      currentUrl += `?`;
    }
    currentUrl += `unReadNotification=${unReadNotification}&unReadMessenger=${unReadMessenger}&unReadProspect=${unReadProspect}`;
  }
  window.open(currentUrl, target);
  if (target === '_self') {
    window.scrollTo(0, 0);
  }
}

export function getNameOfMemberLevel(level) {
  const obj = {
    className: 'level-button guest',
    memberLevel: 'MemberProfileScreen.MemberGuest',
    icon: null,
    fullLevelName: 'MemberProfileScreen.MemberGuest',
  };
  switch (level) {
    case MEMBER_LEVEL.PLUS:
      obj.memberLevel = 'MemberProfileScreen.Plus';
      obj.className = 'level-button plus';
      obj.fullLevelName = 'MemberProfileScreen.Plus';
      break;
    case MEMBER_LEVEL.EXTRAS:
    case MEMBER_LEVEL.PLUS_EXTRAS:
      obj.memberLevel = 'MemberProfileScreen.Extras';
      obj.className = 'level-button extras';
      obj.fullLevelName = 'MemberProfileScreen.Extras';
      break;
    case MEMBER_LEVEL.PREMIUM:
      obj.memberLevel = 'MemberProfileScreen.MemberPremium';
      obj.className = 'level-button premium';
      obj.fullLevelName = 'MemberProfileScreen.MemberPremium';
      break;
    case MEMBER_LEVEL.PREMIUM_PLUS:
      obj.memberLevel = 'MemberProfileScreen.MemberPremiumPlus';
      obj.fullLevelName = 'MemberProfileScreen.MemberPremiumPlus';
      obj.className = 'level-button premium-plus';
      break;
    case MEMBER_LEVEL.PLATINUM:
      obj.memberLevel = 'MemberProfileScreen.MemberPlatinum';
      obj.fullLevelName = 'MemberProfileScreen.MemberPlatinum';
      obj.className = 'level-button platinum';
      break;
    case MEMBER_LEVEL.DIAMOND:
      obj.memberLevel = 'MemberProfileScreen.MemberPlatinum';
      obj.fullLevelName = 'MemberProfileScreen.MemberDiamond';
      obj.className = 'level-button platinum';
      obj.icon = icDiamondMember;
      break;
    default:
      break;
  }
  return obj;
}

export function formatNum(num, sym) {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d)+\.)/g, `${sym || $}1,`);
}

export function formatCurrency(curr) {
  const options = {
    style: 'currency',
    currency: 'USD',
  };
  if (Number(curr) === curr && curr % 1 !== 0) {
    options.minimumFractionDigits = 2;
    options.maximumFractionDigits = 2;
  } else {
    options.maximumSignificantDigits = curr.toString().length;
  }

  return curr.toLocaleString('en-US', { ...options });
}

export function generateParamsUpdateProfile(data) {
  // meta datat https://tstsrvs.redhotpie.com.au/json/metadata?op=PatchUserProfile
  const params = {};
  const paramsKey = {};
  Object.keys(data).forEach(key => {
    switch (key) {
      case 'maritalStatus':
        params.MaritalStatus = data[key];
        paramsKey.MaritalStatus = key;
        break;
      case 'seekingRelationshipStatus':
        params.SeekingMaritalStatus = data[key];
        paramsKey.SeekingMaritalStatus = key;
        break;
      case 'maritalStatus2':
        params.MaritalStatus2 = data[key];
        paramsKey.MaritalStatus2 = key;
        break;
      case 'sexualOrientation':
        params.SexualOrientation = data[key];
        paramsKey.SexualOrientation = key;
        break;
      case 'sexualOrientation2':
        params.SexualOrientation2 = data[key];
        paramsKey.SexualOrientation2 = key;
        break;
      case 'race':
        params.Race = data[key];
        paramsKey.Race = key;
        break;
      case 'race2':
        params.Race2 = data[key];
        paramsKey.Race2 = key;
        break;
      case 'myLooks':
        params.Mylooks = data[key];
        paramsKey.Mylooks = key;
        break;
      case 'myLooks2':
        params.Mylooks2 = data[key];
        paramsKey.Mylooks2 = key;
        break;
      case 'eyeColour':
        params.EyeColour = data[key];
        paramsKey.EyeColour = key;
        break;
      case 'eyeColour2':
        params.EyeColour2 = data[key];
        paramsKey.EyeColour2 = key;
        break;
      case 'hairColour':
        params.HairColour = data[key];
        paramsKey.HairColour = key;
        break;
      case 'hairColour2':
        params.HairColour2 = data[key];
        paramsKey.HairColour2 = key;
        break;
      case 'hairLength':
        params.HairLength = data[key];
        paramsKey.HairLength = key;
        break;
      case 'hairLength2':
        params.HairLength2 = data[key];
        paramsKey.HairLength2 = key;
        break;
      case 'height':
        params.Height = data[key];
        paramsKey.Height = key;
        break;
      case 'height2':
        params.Height2 = data[key];
        paramsKey.Height2 = key;
        break;
      case 'drinking':
        params.Drinking = data[key];
        paramsKey.Drinking = key;
        break;
      case 'drinking2':
        params.Drinking2 = data[key];
        paramsKey.Drinking2 = key;
        break;
      case 'personality':
        params.Personality = data[key];
        paramsKey.Personality = key;
        break;
      case 'personality2':
        params.Personality2 = data[key];
        paramsKey.Personality2 = key;
        break;
      case 'smoking':
        params.Smoking = data[key];
        paramsKey.Smoking = key;
        break;
      case 'smoking2':
        params.Smoking2 = data[key];
        paramsKey.Smoking2 = key;
        break;
      case 'bodyType':
        params.BodyType = data[key];
        paramsKey.BodyType = key;
        break;
      case 'bodyType2':
        params.BodyType2 = data[key];
        paramsKey.BodyType2 = key;
        break;
      case 'birthDate':
        params.Birthdate = data[key];
        paramsKey.Birthdate = key;
        break;
      case 'birthDate2':
        params.Birthdate2 = data[key];
        paramsKey.Birthdate2 = key;
        break;
      //
      case 'postCodeAllID':
        params.PostCodeAllID = data[key];
        paramsKey.PostCodeAllID = key;
        break;
      case 'googleMapPlacesId':
        params.GoogleMapPlacesId = data[key];
        paramsKey.GoogleMapPlacesId = key;
        break;
      case 'bodyHair':
        params.BodyHair = data[key];
        paramsKey.BodyHair = key;
        break;
      case 'bodyHair2':
        params.BodyHair2 = data[key];
        paramsKey.BodyHair2 = key;
        break;
      case 'circumcised':
        params.Circumcised = data[key];
        paramsKey.Circumcised = key;
        break;
      case 'circumcised2':
        params.Circumcised2 = data[key];
        paramsKey.Circumcised2 = key;
        break;
      case 'cupSize':
        params.Cupsize = data[key];
        paramsKey.Cupsize = key;
        break;
      case 'cupSize2':
        params.Cupsize2 = data[key];
        paramsKey.Cupsize2 = key;
        break;
      case 'endowmentLength':
        params.EndowmentLength = data[key];
        paramsKey.EndowmentLength = key;
        break;
      case 'endowmentLength2':
        params.EndowmentLength2 = data[key];
        paramsKey.EndowmentLength2 = key;
        break;
      case 'endowmentThickness':
        params.EndowmentThickness = data[key];
        paramsKey.EndowmentThickness = key;
        break;
      case 'endowmentThickness2':
        params.EndowmentThickness2 = data[key];
        paramsKey.EndowmentThickness2 = key;
        break;
      case 'pubicHair':
        params.Pubichair = data[key];
        paramsKey.Pubichair = key;
        break;
      case 'pubicHair2':
        params.Pubichair2 = data[key];
        paramsKey.Pubichair2 = key;
        break;
      case 'safeSex':
        params.Safesex = data[key];
        paramsKey.Safesex = key;
        break;
      case 'safeSex2':
        params.Safesex2 = data[key];
        paramsKey.Safesex2 = key;
        break;
      case 'sexualPersonality':
        params.SexualPersonality = data[key];
        paramsKey.SexualPersonality = key;
        break;
      case 'sexualPersonality2':
        params.SexualPersonality2 = data[key];
        paramsKey.SexualPersonality2 = key;
        break;
      case 'fantasyActivity':
        params.FantasyActivity = data[key];
        paramsKey.FantasyActivity = key;
        break;
      case 'fantasyLocation':
        params.FantasyLocation = data[key];
        paramsKey.FantasyLocation = key;
        break;
      case 'fantasyMustHave':
        params.FantasyMustHave = data[key];
        paramsKey.FantasyMustHave = key;
        break;
      case 'intimatePiercing':
        params.IntimatePiercing = data[key];
        paramsKey.IntimatePiercing = key;
        break;
      case 'intimatePiercing2':
        params.IntimatePiercing2 = data[key];
        paramsKey.IntimatePiercing2 = key;
        break;
      case 'mood':
        params.Mood = data[key];
        paramsKey.Mood = key;
        break;
      case 'seekingYoungest':
        params.SeekingYoungest = data[key];
        paramsKey.SeekingYoungest = key;
        break;
      case 'seekingOldest':
        params.SeekingOldest = data[key];
        paramsKey.SeekingOldest = key;
        break;
      case 'seekingStateID':
        params.SeekingStateID = data[key];
        paramsKey.SeekingStateID = key;
        break;
      case 'seekingTypes':
        params.SeekingTypes = data[key];
        paramsKey.SeekingTypes = key;
        break;
      case 'seekingMaritalStatus':
        params.SeekingMaritalStatus = data[key];
        paramsKey.SeekingMaritalStatus = key;
        break;
      case 'fetishInterest':
        params.FetishInterest = data[key];
        paramsKey.FetishInterest = key;
        break;
      case 'generalInterest':
        params.GeneralInterest = data[key];
        paramsKey.GeneralInterest = key;
        break;
      case 'sexualInterest':
        params.SexualInterest = data[key];
        paramsKey.SexualInterest = key;
        break;
      case 'sexualPreference':
        params.SexualPreference = data[key];
        paramsKey.SexualPreference = key;
        break;
      case 'intention':
        params.Intention = data[key];
        paramsKey.Intention = key;
        break;
      case 'seekingBody':
        params.SeekingBody = data[key];
        paramsKey.SeekingBody = key;
        break;
      case 'introBody':
        params.IntroBody = data[key];
        paramsKey.IntroBody = key;
        break;
      case 'introTitle':
        params.IntroTitle = data[key];
        paramsKey.IntroTitle = key;
        break;
      case 'fetishInterestValues':
        params.FetishInterestValues = data[key];
        paramsKey.FetishInterestValues = key;
        break;
      case 'sexualInterestValues':
        params.SexualInterestValues = data[key];
        paramsKey.SexualInterestValues = key;
        break;
      case 'seekingTypeValues':
        params.SeekingTypeValues = data[key];
        paramsKey.SeekingTypeValues = key;
        break;
      case 'generalInterestValues':
        params.GeneralInterestValues = data[key];
        paramsKey.GeneralInterestValues = key;
        break;
      case 'sexualPreferenceValues':
        params.SexualPreferenceValues = data[key];
        paramsKey.SexualPreferenceValues = key;
        break;
      case 'participation':
        params.LevelOfParticipation = data[key];
        paramsKey.LevelOfParticipation = key;
        break;
      case 'participation2':
        params.LevelOfParticipation2 = data[key];
        paramsKey.LevelOfParticipation2 = key;
        break;
      case 'dealBreaker':
        params.DealBreakers = data[key];
        paramsKey.DealBreakers = key;
        break;
      case 'showMutualInterestsOnly':
        params.ShowMutualInterestsOnly = data[key];
        paramsKey.ShowMutualInterestsOnly = key;
        break;
      default:
        break;
    }
  });
  return { params, pramsKey: paramsKey };
}

export function getVerifyOfUser(typeVerify) {
  let res = {
    isVerify: false,
    isPending: false,
  };

  switch (typeVerify) {
    case 'Verified':
      res = { isVerify: true, isPending: false };
      break;
    case 'Pending':
      res = { isPending: true, isVerify: false };
      break;
    default:
      break;
  }

  return res;
}

export function isDateInThePast(date) {
  // eslint-disable-next-line no-useless-catch
  try {
    const customDate = moment(date).add(12, 'hours');
    return moment(customDate).isBefore(moment());
  } catch (e) {
    throw e;
  }
}

export function getFirstMatchingConversation(conversations) {
  let result = {};
  for (let i = 0; i < conversations.length; i++) {
    if (conversations[i].peerVcard.isMatch) {
      result = conversations[i];
      break;
    }
  }
  return result;
}

export function convertEnterStringToTagHTML(str) {
  let newString = '';
  if (str) {
    for (let i = 0; i < str.length; i++) {
      newString += str.charCodeAt(i) === 10 ? '<br />' : str[i];
    }
  }

  return newString;
}

export function convertLocation(str) {
  let res = '';
  if (str) {
    res = str.split(',')[0];
  }
  return res;
}

export function getMemberLevel(level, diamond) {
  let res = level || MEMBER_TYPES.GUEST;
  if (level >= MEMBER_TYPES.PLATINUM && diamond) {
    res = MEMBER_TYPES.PLATINUM_DIAMOND;
  }
  return res;
}

// get place detail base on latitude and longitude
// lat: latitude, lng: longitude
export function getPlaceDetailFromCoordinates(lat, lng) {
  return GoogleService.getPlaceDetailFromCoordinates(lat, lng);
}

// Calculate distance between two points
// p1 and p2 are google.maps.LatLng(x,y) objects: { lat: latitude value, long: longitude value }
export function calcDistance(p1, p2) {
  return GoogleService.calcDistance(p1, p2);
}

export function ccFormat(value) {
  const v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
  const matches = v.match(/\d{4,16}/g);
  const match = (matches && matches[0]) || '';
  const parts = [];

  for (let i = 0, len = match.length; i < len; i += 4) {
    parts.push(match.substring(i, i + 4));
  }
  if (parts.length) {
    return parts.join(' ');
  }
  return v;
}

export function ccFormatStr(value) {
  const parts = [];

  for (let i = 0, len = value.length; i < len; i += 1) {
    if (i % 4 === 0 && i !== 0) {
      parts.push(' ');
    }
    parts.push(value[i] !== 'x' && i < value.length - 4 ? 'x' : value[i]);
  }
  if (parts.length) {
    return parts;
  }
  return value;
}

export function formatPhoneNumberStr(value) {
  let v = value;
  if (v.charAt(0) === '0') {
    v = v.substring(1, v.length);
  }
  v = v.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
  const matches = v.match(/\d{3,12}/g);
  const match = (matches && matches[0]) || '';
  const parts = [];

  for (let i = 0, len = match.length; i < len; i += 3) {
    parts.push(match.substring(i, i + 3));
  }
  if (parts.length) {
    return parts.join(' ');
  }
  return v;
}

export function formatNumber(str) {
  return str.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
}

export function isSelectedSubTab(selectingCategory, tabId) {
  let isSelectedSubTab = false;
  if (selectingCategory && selectingCategory.id) {
    const subTabs = selectingCategory.subTabs || [];
    let indexTab = 0;
    if (subTabs && subTabs.length) {
      subTabs.forEach((item, index) => {
        if (item.id === tabId) {
          indexTab = index;
          isSelectedSubTab = item.isSelected;
        }
      });
    }
  }
  return isSelectedSubTab;
}

export function buildHeightData(value, dataSource, index, midIndex) {
  // let activeIndex = dataSource.findIndex(x => x.id === value.id);
  const activeIndex = findIndex(dataSource, x => {
    return x.id === value.id;
  });
  const currentIndex = activeIndex - midIndex + index;
  if (dataSource[currentIndex]) {
    return dataSource[currentIndex];
  }
  return currentIndex > 0 ? { id: currentIndex + 1 } : { id: currentIndex - 1 };
}

export function getBackScreen(currentScreen) {
  switch (currentScreen) {
    case SCREENS_NAME.LOOKING_TO_MEET: {
      return {
        backCategoryId: CATEGORY_ID.LTM_LOOKING_FOR,
        backScreen: SCREENS_NAME.SPLASH,
      };
    }
    case SCREENS_NAME.TELL_US_ABOUT_YOURSELF_1: {
      return {
        backCategoryId: CATEGORY_ID.LTM_INTENTIONS,
        backScreen: SCREENS_NAME.LOOKING_TO_MEET,
      };
    }
    case SCREENS_NAME.TELL_US_ABOUT_YOURSELF_2: {
      return {
        backCategoryId: CATEGORY_ID.TU1_ETHNICITY,
        backScreen: SCREENS_NAME.TELL_US_ABOUT_YOURSELF_1,
      };
    }
    case SCREENS_NAME.WHAT_ARE_YOUR_INTERESTS: {
      return {
        backCategoryId: CATEGORY_ID.TU2_ORIENTATION,
        backScreen: SCREENS_NAME.TELL_US_ABOUT_YOURSELF_2,
      };
    }
    case SCREENS_NAME.INTRODUCE_YOURSELF: {
      return {
        backCategoryId: CATEGORY_ID.WYI_FETISH,
        backScreen: SCREENS_NAME.WHAT_ARE_YOUR_INTERESTS,
      };
    }
    case SCREENS_NAME.CREATE_ACCOUNT: {
      return {
        backCategoryId: CATEGORY_ID.WYI_FETISH,
        backScreen: SCREENS_NAME.INTRODUCE_YOURSELF,
      };
    }
    default: {
      return {
        backCategoryId: CATEGORY_ID.LTM_LOOKING_FOR,
        backScreen: SCREENS_NAME.SPLASH,
      };
    }
  }
}

export function addZeroForMonth(month) {
  let text = month;
  if (Number.parseInt(month) < 10) {
    text = `0${month}`;
  }

  return text;
}

export function getLastIndexOfString(data, rex) {
  if (data) {
    const arr = data.split(rex);
    return arr[arr.length - 1].trim();
  }
  return data;
}

export function openDeepLinkingApp(url = DEEP_LINKING_APP, params) {
  let urlDeepLink = url;
  if (params) {
    urlDeepLink += `?${params}`;
  }

  window.open(urlDeepLink);
}

export function openTransFormPage() {
  window.open(`${window.location.origin}${ROOT_FOLDER}/${AUTHORIZE}/${TRANSFORM_PAGE}`, '_self');
}

export function countTagBrOfString(str) {
  return (str.match(new RegExp('<br />', 'g')) || []).length;
}

export function getPageOfIndex(index, pageLength) {
  return Math.floor(index / pageLength);
}

export function checkIndexOfPage(index, pageNumber, pageLength) {
  return Math.floor(index / pageLength) === pageNumber;
}

export function getOS() {
  const { userAgent, platform } = window.navigator;
  const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
  const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
  const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
  let os;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'OSX';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows';
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
  } else {
    os = 'Other';
  }

  return os;
}

export function parseCreateDateFinderObject(o) {
  return {
    Dates: o.dates,
    MeetingTypes: o.meetingTypes,
    SeekingTypes: o.seekingTypes,
    AgeMin: o.ageMin,
    AgeMax: o.ageMax,
    Comment: o.comment,
    GoogleMapPlaceID: o.googleMapPlaceID,
    CanHost: o.canHost,
  };
}

export function parseCreateTravelPlanObject(o) {
  const res = {
    DateArrived: o.dateArrived,
    DateDeparture: o.dateDeparture,
    IsHidden: o.isHidden,
    Description: o.description,
    LocationGID: o.googleMapPlaceID,
    UserTravelProfileID: o.userTravelProfileID ? o.userTravelProfileID : 0,
  };
  if (!!o.showSimpleDates) {
    res.ShowSimpleDates = o.showSimpleDates;
  }
  return res;
}

export function decimalToBinary(num) {
  // takes a number
  let power = 2; // because binary is base 2, each place is to the higher power
  let pow = 0;
  const powArr = [];
  let binaryStr = ''; // to hold results
  while (!!num) {
    // while number is a truthy value...
    const remainder = num % power; // get remainder from dividing by the power
    const digit = remainder ? 1 : 0; // the remainder should be between 0 and the power which will be truthy or falsy and return 1 or 0 from the ternary
    if (digit) {
      powArr.push(remainder);
    }
    binaryStr = digit + binaryStr; // add the digit to the binary str
    // eslint-disable-next-line no-param-reassign
    num -= remainder; // subtract the remainder from the number because we've accounted for it in the binary string
    power *= 2; // increase the power by one more place in the binary
    pow++;
  }
  return powArr; // return the completed binary string when the number is a falsy value, eg: 0
}

export function convertUnixTimestampToISODate(date) {
  return moment(date).format('YYYY-MM-DDThh:mm:ss');
}

export function convertDateToDateASPDotNet(date) {
  if (date) {
    return `/Date(${date.valueOf()}${date.format('ZZ')})/`;
  }
  return undefined;
}

export function parseDateString(dateString) {
  const regex = /\/Date\((\d+)([+-]\d{4})?\)\//;
  const match = dateString.match(regex);
  if (match) {
    const timestamp = parseInt(match[1], 10);
    return new Date(timestamp);
  }
  return null; // or handle error as needed
}

export function checkSafeMode(user, userLogin) {
  if (user) {
    return (
      (user?.mainPhotoSummary?.imageActionType || user?.mainPhoto?.imageActionType) === IMAGE_ACTION_TYPE.SAFE_MODE &&
      userLogin?.userInfo?.safeMode
    );
  }
  return userLogin?.userInfo?.safeMode;
}

export function getMemberLevelUserLogin(upgradeMember) {
  switch (upgradeMember) {
    case UPGRADE_PATH_TYPE.PLATINUM:
      return {
        className: 'upgrade-platinum',
        btnName: 'OutOfUser.GetType',
        btnType: 'UpgradeMember.Platinum',
        descriptionBtn: 'OutOfUser.desBtn',
        desBtnCount: 50,
        descriptionBtnLike: 'OutOfUser.desBtnLike',
        desBtnLikeCount: 100,
        descriptionBtnFavourite: 'OutOfUser.desBtnFavourite',
        desBtnFavCount: 20,
        infoUpgrade1: 'OutOfUser.GetMoreWith',
        ifUgType: 'UpgradeMember.Platinum',
        infoUpgrade2: 'OutOfUser.MoreChatMorFav',
        isBlack: false,
      };
    case UPGRADE_PATH_TYPE.DIAMOND:
      return {
        className: 'upgrade-diamond',
        btnName: 'OutOfUser.GetType',
        btnType: 'UpgradeMember.Diamond',
        descriptionBtn: 'OutOfUser.UnlimitedConversations',
        desBtnCount: 0,
        descriptionBtnLike: 'OutOfUser.UnlimitedLike',
        desBtnLikeCount: 0,
        descriptionBtnFavourite: 'OutOfUser.UnlimitedFav',
        desBtnFavCount: 0,
        infoUpgrade1: 'OutOfUser.GetMoreWith',
        ifUgType: 'UpgradeMember.Diamond',
        infoUpgrade2: 'OutOfUser.UnlimitedConversations',
        isBlack: true,
      };
    case UPGRADE_PATH_TYPE.EXTRAS:
      return {
        btnName: 'Btn.GetExtras',
        className: 'upgrade-button',
      };
    default:
      return null;
  }
}

export function convertOwnerFromLoginReducerOrUser(loginReducer, user, isUserOwner) {
  return {
    userId: isUserOwner ? loginReducer.userInfo.userId : (user.detail && user.detail.userId) || user.userId || -1,
    avatarUrl: isUserOwner
      ? loginReducer.userInfo.avatarUrl
      : (user.mainPhotoSummary && user.mainPhotoSummary.thumbUrl) || (user.mainPhoto && user.mainPhoto.thumbUrl),
    displayName: isUserOwner ? loginReducer.userInfo.displayName : (user.detail && user.detail.userName) || user.userName || '',
    ageTitle: isUserOwner ? loginReducer.userInfo.ageTitle : (user.detail && user.detail.ageTitle) || user.ageTitle || '',
    location: isUserOwner
      ? loginReducer.userInfo.location
      : (user.detail && `${user.detail.location}, ${user.detail.stateName}`) || `${user.location}, ${user.stateName || ''}` || '',
  };
}

/**
 * getCurrentAEDTDate function
 * @returns {moment.Moment}
 */
export function getCurrentAEDTDate() {
  const aestTime = new Date().toLocaleString('en-US', {
    timeZone: 'Australia/Brisbane',
  });
  return moment(aestTime);
}

export function formatNumberShowNDecimalPlaces(number, decimal) {
  return Number(number).toFixed(decimal);
}

export function convertActorForForum(actor) {
  return (
    // eslint-disable-next-line no-prototype-builtins
    (actor.hasOwnProperty('userId') && {
      userId: actor.userId,
      avatarUrl: actor.mainPhoto && actor.mainPhoto.thumbUrl,
      userName: actor.userName,
    }) || {
      userId: -1,
      avatarUrl: noPhoto,
      userName: 'Not found',
    }
  );
}

export function getLatLongCurrentLocation(callback) {
  const store = getStore();
  let currLocal = {};
  const { currentLocation } = store.getState().commonStateReducer;
  // eslint-disable-next-line no-prototype-builtins
  if (!currentLocation.coordinates && navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      position => {
        const { latitude, longitude } = position.coords;
        currLocal = {
          ...currentLocation,
          coordinates: { latitude, longitude },
          loadSuccess: true,
        };
        store.dispatch(commonStateActions.updateStateCommonState(['currentLocation'], currLocal));
        if (typeof callback === 'function') {
          callback(currLocal);
        }
      },
      error => {
        console.log('Error get location: ', error);
        currLocal = {
          ...currentLocation,
          error: { errorCode: error.code, errorMessage: error.message },
          loadSuccess: true,
        };
        store.dispatch(commonStateActions.updateStateCommonState(['currentLocation'], currLocal));
        if (typeof callback === 'function') {
          callback(currLocal);
        }
      }
    );
  }
}

export function gotoRHPURLWithIframe(url, params) {
  const appToken = getKey(SESSIONS.RHP_TOKEN);
  const supportUrl = url.replace('{Token}', appToken);
  const store = getStore();
  store.dispatch(
    commonStateActions.updateCommonStateReducerSuccess({
      isShowBrowserModal: true,
      urlBrowserModal: `${window.location.origin}${supportUrl}` || '',
      isFeedback: params?.isFullWidth ? false : true,
    })
  );
}

/**
 *
 * @param time: type moment
 * @returns {number}
 */
export function getMinuteSimpleMode(time) {
  return time.get('minute') < 30 ? 0 : 30;
}

export function getVisibilityOfAllBrowser() {
  let visibilityHidden = 'hidden';
  let visibilityChange = 'visibilitychange';

  if (typeof document.mozHidden !== 'undefined') {
    visibilityHidden = 'mozHidden';
    visibilityChange = 'mozvisibilitychange';
  } else if (typeof document.msHidden !== 'undefined') {
    visibilityHidden = 'msHidden';
    visibilityChange = 'msvisibilitychange';
  } else if (typeof document.webkitHidden !== 'undefined') {
    visibilityHidden = 'webkitHidden';
    visibilityChange = 'webkitvisibilitychange';
  }

  return { visibilityChange, visibilityHidden };
}

export function convertItemForPicker(items, property) {
  const newItems = [];

  items.forEach(itm => {
    newItems.push(itm[property]);
  });

  return newItems;
}

export const getCurrentTimeZone = (number, maxDigit = 10) => {
  const currentTimeZoneOffSet = number !== undefined && number !== null ? number : (new Date().getTimezoneOffset() / 60) * -1;
  let hours = 0;
  let minutes = 0;
  let timeString = '';
  const absNum = Math.abs(currentTimeZoneOffSet);
  hours = Math.floor(absNum);
  minutes = Math.abs((absNum - hours) * 60);
  if (hours < maxDigit) {
    hours = `0${hours}`;
  }
  if (minutes < maxDigit) {
    minutes = `0${minutes}`;
  }
  timeString = `${hours}:${minutes}`;
  if (currentTimeZoneOffSet < 0) {
    return `-${timeString}`;
  }
  return `+${timeString}`;
};

/**
 *
 * @param memberType
 * @param isTheSecondOne: mean the women
 * @returns {string}
 */
export const getColorByMemberType = (memberType = MEMBER_TYPES_REGISTER.NULL, isTheSecondOne = false) => {
  let classColor = '';
  switch (memberType) {
    case MEMBER_TYPES_REGISTER.COUPLES:
      classColor = isTheSecondOne ? COLOR_MEMBER_TYPE.PINK : COLOR_MEMBER_TYPE.BLUE;
      break;
    case MEMBER_TYPES_REGISTER.MEN:
    case MEMBER_TYPES_REGISTER.COUPLES_MM:
      classColor = COLOR_MEMBER_TYPE.BLUE;
      break;
    case MEMBER_TYPES_REGISTER.WOMEN:
    case MEMBER_TYPES_REGISTER.COUPLES_FF:
      classColor = COLOR_MEMBER_TYPE.PINK;
      break;
    default:
      classColor = COLOR_MEMBER_TYPE.GRAY;
      break;
  }
  return classColor;
};

export function mappingParamGetUsersActive(params = {}) {
  return {
    SeekingType: params?.seekingType || 0,
    MinAge: params?.minAge || undefined,
    MaxAge: params?.maxAge || undefined,
    IsMatch: params?.isMatch || false,
    Size: params?.size || DEFAULT_PAGE_SIZE_ACTIVE_USERS,
    Radius: params?.radius > -1 ? params?.radius : 0,
    GoogleMapPlace: params?.googleMapPlace || { PlacesId: '', Types: [''] },
    // GoogleMapPlace: params.googleMapPlace ? JSON.stringify(params.googleMapPlace).replace(/"/g, "") : {}
    // page:0 // We do not need pageNumber, only get first 10 items (in messenger screen) or first 200 items (see all case)
  };
}

export function formatDateTimeString(date, timeZone) {
  let dStr = '';
  let strTime = '';
  if (date) {
    const datetime = new Date(new Date(date).toLocaleString('en-US', { timeZone }));
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const d = datetime.getDate();
    const dd = days[datetime.getDay()];
    const mm = months[datetime.getMonth()];
    dStr = `${dd} ${d} ${mm} ${datetime.getFullYear()}`;
    let hours = datetime.getHours();
    let minutes = datetime.getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours %= 12;
    hours = hours || 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? `0${minutes}` : minutes;
    strTime = `${hours}:${minutes} ${ampm}`;
  }

  return {
    dStr,
    strTime,
  };
}

export function formatDateTimeWithTimezone(date, timeZone = '') {
  const option = {};
  if (timeZone !== '') {
    option.timeZone = timeZone;
  }
  return new Date(new Date(date).toLocaleString('en-US', option));
}

export function formatNumberIntoKorM(number, customMaximum) {
  let res = number;

  if (customMaximum) {
    if (res > customMaximum) {
      res = `${customMaximum}+`;
    }
  } else {
    if (res > 999999) {
      if (res === 1000000) {
        res = '1m';
      } else {
        res = `${Math.floor(res / 1000000)}m+`;
      }
    } else if (res > 999) {
      if (res === 1000) {
        res = '1k';
      } else {
        res = `${Math.floor(res / 1000)}k+`;
      }
    }
  }

  return res;
}

export function checkFileExtentions(file = '') {
  // image
  // FileUploadType.jpg,
  // FileUploadType.jpeg,
  // FileUploadType.png,
  // //video
  // FileUploadType.mp4,
  // FileUploadType.avi,
  // FileUploadType.mov,
  // FileUploadType.webm,
  // FileUploadType.wmv,
  // FileUploadType.mkv,
  // FileUploadType.flv
  let ext = '';
  if (file) {
    ext = file.split('.').pop().toLowerCase();
  }
  switch (ext) {
    case 'mp4':
    case 'avi':
    case 'mov':
    case 'webm':
    case 'wmv':
    case 'mkv':
    case 'flv':
      return 'video';

    case 'jpg':
    case 'jpeg':
    case 'png':
      return 'image';

    default:
      return '';
  }
}

export function objectToFormData(obj, rootName, ignoreList) {
  const formData = new FormData();

  function appendFormData(data, root) {
    if (!ignore(root)) {
      // eslint-disable-next-line no-param-reassign
      root = root || '';
      if (data instanceof File) {
        formData.append(root, data);
      } else if (Array.isArray(data)) {
        for (let i = 0; i < data.length; i++) {
          appendFormData(data[i], `${root}[${i}]`);
        }
      } else if (typeof data === 'object' && data) {
        Object.keys(data).forEach(key => {
          // eslint-disable-next-line no-prototype-builtins
          if (data.hasOwnProperty(key)) {
            if (root === '') {
              appendFormData(data[key], key);
            } else {
              appendFormData(data[key], `${root}.${key}`);
            }
          }
        });
      } else {
        if (data !== null && typeof data !== 'undefined') {
          formData.append(root, data);
        }
      }
    }
  }

  function ignore(root) {
    return (
      Array.isArray(ignoreList) &&
      ignoreList.some(x => {
        return x === root;
      })
    );
  }

  appendFormData(obj, rootName);

  return formData;
}

export const generateBodyComment = params => {
  const body = {
    ID: params.id,
    Message: params.message,
    MessageContentType: params.contentType || 'Text',
  };
  if (params.commentParentID) {
    body.CommentParentID = params.commentParentID;
  }
  return body;
};
export const createFormDataComment = (params, body) => {
  let file = {};
  let result = body;
  if (params.media) {
    if (params.contentType === COMMENT_MESSAGE_CONTENT_TYPE.GIFFY) {
      result.GiphyImage = { GiphyImageID: params.media.id };
      if (params.media.images && params.media.images.fixed_height) {
        result.GiphyImage = {
          ...result.GiphyImage,
          height: parseFloat(params.media.images.fixed_height.height),
          width: parseFloat(params.media.images.fixed_height.width),
        };
      }
    }
    if (params.contentType === COMMENT_MESSAGE_CONTENT_TYPE.IMAGE) {
      if (isNative) {
        file = {
          uri: params.media.uri,
          name: params.media.name,
          type: params.media.type,
        };
      } else {
        file = params.media;
      }
    }
  }
  if (params.contentType === COMMENT_MESSAGE_CONTENT_TYPE.IMAGE) {
    const formData = objectToFormData(body);
    formData.append('file', file);
    result = formData;
  }
  return result;
};

export function generateQueryString(query) {
  let queryString = '';
  if (query) {
    const queryKeys = Object.keys(query);
    queryKeys.forEach(key => {
      if (query[key]) {
        if (query[key].toString().length) {
          queryString += `${key}=${query[key]}&`;
        }
      }
    });
    if (queryKeys.length > 0 && queryString[queryString.length - 1] === '&') {
      queryString = queryString.slice(0, -1);
    }
  }
  return queryString;
}

export function addParamsToQueryString(url, params) {
  if (params) {
    const queryString = Object.keys(params)
      .map(key => `${key}=${params[key]}`)
      .join('&');
    return `${url}${queryString ? '?' : ''}${queryString}`;
  }
  return url;
}

export function detectFullBrowser() {
  const res = {
    name: window.navigator.appName,
    version: window.navigator.appVersion,
  };
  const navUserAgent = window.navigator.userAgent.toUpperCase();
  let ix;
  let tempVersionOffset;
  let tempNameOffset;

  // eslint-disable-next-line no-cond-assign
  if ((tempVersionOffset = navUserAgent.indexOf(OPERA)) !== -1) {
    res.name = OPERA;
    res.version = navUserAgent.substring(tempVersionOffset + 6);
    tempVersionOffset = navUserAgent.indexOf(VERSION);
    if (tempVersionOffset !== -1) {
      res.version = navUserAgent.substring(tempVersionOffset + 8);
    }
  } else {
    tempVersionOffset = navUserAgent.indexOf(MSIE);
    if (tempVersionOffset !== -1) {
      res.name = IE;
      res.version = navUserAgent.substring(tempVersionOffset + 5);
    } else {
      tempVersionOffset = navUserAgent.indexOf(CRIOS);
      if (tempVersionOffset !== -1) {
        res.name = CHROME_IOS;
        res.version = navUserAgent.substring(tempVersionOffset + 6);
      } else {
        tempVersionOffset = navUserAgent.indexOf(CHROME);
        if (tempVersionOffset !== -1) {
          res.name = CHROME;
          res.version = navUserAgent.substring(tempVersionOffset + 7);
        } else {
          tempVersionOffset = navUserAgent.indexOf(FXIOS);
          if (tempVersionOffset !== -1) {
            res.name = FIREFOX_IOS;
            res.version = navUserAgent.substring(tempVersionOffset + 6);
          } else {
            tempVersionOffset = navUserAgent.indexOf(FIREFOX);
            if (tempVersionOffset !== -1) {
              res.name = FIREFOX;
              res.version = navUserAgent.substring(tempVersionOffset + 8);
            } else {
              tempVersionOffset = navUserAgent.indexOf(SAFARI);
              if (tempVersionOffset !== -1) {
                res.name = SAFARI;
                res.version = navUserAgent.substring(tempVersionOffset + 7);
                tempVersionOffset = navUserAgent.indexOf(VERSION);
                if (tempVersionOffset !== -1) {
                  res.version = navUserAgent.substring(tempVersionOffset + 8);
                }
              } else {
                tempNameOffset = navUserAgent.lastIndexOf(' ') + 1;
                tempVersionOffset = navUserAgent.lastIndexOf('/');
                if (tempNameOffset < tempVersionOffset) {
                  res.name = navUserAgent.substring(tempNameOffset, tempVersionOffset);
                  res.version = navUserAgent.substring(tempVersionOffset + 1);
                }
              }
            }
          }
        }
      }
    }
  }

  ix = res.version.indexOf(';');
  if (ix !== -1) {
    res.version = res.version.substring(0, ix);
  }
  ix = res.version.indexOf(' ');
  if (ix !== -1) {
    res.version = res.version.substring(0, ix);
  }

  return res;
}

export function getKeyOTG(params) {
  let res = 'otg';
  if (!(!params || !params.category || params.category === ON_THE_GROUND_LOOKUP_TYPE.ALL)) {
    res = params.category === ON_THE_GROUND_LOOKUP_TYPE.GALLERY ? 'otgGallery' : 'otgVideo';
  }
  return res;
}

export function getOtherKeyOTG(params) {
  let res = 'otg';
  if (!(!params || !params.category || params.category === ON_THE_GROUND_LOOKUP_TYPE.ALL)) {
    res = params.category !== ON_THE_GROUND_LOOKUP_TYPE.GALLERY ? 'otgGallery' : 'otgVideo';
  }

  return res;
}

/**
 * @param props: type: PERMISSION_PROPS
 * @return {object}
 * */
export function getPermissionWithProp(props) {
  const userLogin = getStore().getState().loginReducer;
  // eslint-disable-next-line no-prototype-builtins
  if (userLogin && userLogin.userInfo && userLogin.userInfo.grants && userLogin.userInfo.grants.hasOwnProperty(props)) {
    return userLogin.userInfo.grants[props];
  }
  return { [props]: {} };
}

/*
 *
 * */
export function handleNotification(isSuccess, message, icLeft) {
  const store = getStore();
  let param = { isFailedNotification: true };
  if (isSuccess) {
    param = {
      message,
      iconLeft: icLeft,
      isQuickMessage: true,
      isFailedNotification: !isSuccess,
    };
  }
  store.dispatch(commonStateActions.updateInAppNotificationData(param));
}

export function handleShowNotificationFromResult(res, message) {
  let icon = icTickCircle;
  if (!res.success) {
    icon = res.message ? icNotificationWrong : undefined;
  }

  const notifySetting = {
    success: res.success ? res.success : !!res.message,
    message: res.success ? message : res.message,
    icon,
  };
  handleNotification(notifySetting.success, notifySetting.message, notifySetting.icon);
}

/*
 *
 * */
export function handleShowConfirmModal({
  headerText = '',
  messageConfirm,
  messageConfirmExternal = '',
  messageConfirmExternal2 = '',
  okText = '',
  okAction = callback => {},
  cancelText = '',
  cancelAction = () => {},
  className = STYLE_MODAL.BLOCK_MODAL,
  customClassButton = '',
  customClassCancle = '',
  customClassOk = '',
  disableCancel = false,
  disableClickOverlay = false,
  noClearCancelAction = false,
  keepModalWhenClickCancel = false,
  isMoreEndGroupChat = false,
  disableEscClose = false,
  disableBackBrowserCloseModal = false,
  wrapperPosition = 0,
  extraFooter = null,
  callbackRunAnimation = null,
  noClearCallbackRunAnimation = false,
  isBottomModal = false,
  isOptionModal = false,
  customZIndex = '',
}) {
  const store = getStore();
  const isMobile = phoneDetect();

  store.dispatch(
    commonStateActions.onShowConfirmModal({
      headerText,
      messageConfirm,
      messageConfirmExternal,
      messageConfirmExternal2,
      onOkAction: (callbackCancel, callbackRunAnimation, params) => {
        if (typeof okAction === 'function') {
          okAction(params);
        }
      },
      okText,
      classNames: `${className} ${!isMobile ? 'notification-modal-desktop' : ''}`,
      cancelText: cancelText,
      onCancelAction: () => {
        if (typeof cancelAction === 'function') {
          cancelAction();
        }
      },
      disableCancel,
      disableClickOverlay,
      customClassOk,
      noClearCancelAction,
      keepModalWhenClickCancel,
      customClassCancle,
      isMoreEndGroupChat,
      wrapperPosition,
      disableEscClose,
      disableBackBrowserCloseModal,
      customClassButton,
      extraFooter,
      callbackRunAnimation,
      noClearCallbackRunAnimation,
      isBottomModal,
      isOptionModal,
      customZIndex,
    })
  );
}

export function handleUpdateProfileNotFound(userId, user) {
  getStore().dispatch(
    memberProfileActions.getMemberProfileSuccess(userId, {
      ...user,
      isProfileNotFound: true,
      isLoadingGallery: false,
      isLoadingPhotoAPI: false,
    })
  );
}

export function hasOwnProperty(prop, value) {
  if (!prop) {
    return false;
  }
  return Object.prototype.hasOwnProperty.call(prop, value) && prop[value] !== undefined;
}

export function timerParsing(exptsTime, minIsHour = false) {
  if (!exptsTime) {
    return null;
  }
  const oneMinutes = 1000 * 60;
  const oneHour = oneMinutes * 60;
  const oneDay = oneHour * 24;
  const endOfTime = exptsTime - new Date().getTime();
  // Seconds
  if (endOfTime < oneMinutes) {
    if (minIsHour) {
      return 'Under an hour';
    }
    const seconds = Math.round(endOfTime / 1000);
    if (seconds <= 1) {
      return `${seconds} second`;
    }
    return `${seconds} seconds`;
  }
  // Minutes
  if (endOfTime < oneHour) {
    if (minIsHour) {
      return 'Under an hour';
    }
    const minutes = Math.round(endOfTime / oneMinutes);
    if (minutes <= 1) {
      return `${minutes} minute`;
    }
    return `${minutes} minutes`;
  }
  // Hours
  if (endOfTime < oneDay) {
    const hours = Math.round(endOfTime / oneHour);
    if (hours <= 1) {
      return `${hours} hour`;
    }
    return `${hours} hours`;
  }
  // Days
  const days = Math.round(endOfTime / oneDay);
  if (days <= 1) {
    return `${days} day`;
  }
  return `${days} days`;
}

export const timerParsingChatRoom = exptsTime => {
  if (!exptsTime) {
    return null;
  }
  const hours = exptsTime / 3600;
  if (hours / 24 <= 1) {
    return moment.utc(exptsTime * 1000).format('HH:mm:ss');
  }
  const days = Math.round(hours / 24);
  if (days <= 1) {
    return `${days} day`;
  }
  return `${days} days`;
};

export const msToHMS = ms => {
  // 1- Convert to seconds:
  let seconds = ms / 1000;
  // 2- Extract hours:
  const hours = parseInt(seconds / 3600); // 3,600 seconds in 1 hour
  seconds %= 3600; // seconds remaining after extracting hours
  // 3- Extract minutes:
  const minutes = parseInt(seconds / 60); // 60 seconds in 1 minute
  // 4- Keep only seconds not extracted to minutes:
  seconds = Math.round(seconds % 60);
  return `${hours ? pad(hours) : ''}${hours ? ':' : ''}${pad(minutes)}:${pad(seconds)}`;
};

function pad(n) {
  return n < 10 ? `0${n}` : n;
}

export function handleShowDisappearingPhotosModal() {
  const store = getStore();
  store.dispatch(
    commonStateActions.updateCommonStateReducerSuccess({
      isShowDisappearingPhotos: true,
    })
  );
}

export function handleShowThePiePledgeModal() {
  const store = getStore();
  store.dispatch(
    commonStateActions.updateCommonStateReducerSuccess({
      isShowThePiePledgeModal: true,
    })
  );
}

export function handleShowToolTips() {
  const store = getStore();
  const {
    loginReducer: {
      userInfo: { toolTips, accountRequiresAuthentication },
    },
    commonStateReducer: { hadShowNotification },
  } = store.getState();
  let itemTooltip;
  let showTooltip = accountRequiresAuthentication;

  if (!hadShowNotification) {
    if (showTooltip) {
      store.dispatch(
        commonStateActions.updateCommonStateReducerSuccess({
          isShowAuthenticationModal: true,
        })
      );
    } else {
      itemTooltip = toolTips.find(itm => OnBoardingNotification === itm.name);
      showTooltip = (itemTooltip && itemTooltip.display) || false;
      if (showTooltip) {
        store.dispatch(newFeedActions.mergeDataHome({ isShowOnBoardingNotification: true }));
      } else {
        itemTooltip = toolTips.find(itm => AddPhoneNumber === itm.name) || null;
        showTooltip = (itemTooltip && itemTooltip.display) || false;
        if (showTooltip) {
          store.dispatch(
            commonStateActions.updateCommonStateReducerSuccess({
              isShowSecureAccount: true,
            })
          );
        } else {
          itemTooltip = toolTips.find(itm => TiredOfRememberingPassword === itm.name);
          showTooltip = (itemTooltip && itemTooltip.display && getMobileOperatingSystem() !== OPERATING_SYSTEM.ANDROID) || false;
          if (showTooltip) {
            store.dispatch(
              commonStateActions.updateCommonStateReducerSuccess({
                isShowTriedRememberingPassword: true,
              })
            );
          } else {
            itemTooltip = toolTips.find(itm => IntroducingBoost === itm.name);
            showTooltip = (itemTooltip && itemTooltip.display) || false;
            if (showTooltip) {
              store.dispatch(
                commonStateActions.updateCommonStateReducerSuccess({
                  isShowIntroducingMessengerBoostModal: true,
                })
              );
            }
          }
        }
      }
    }
    store.dispatch(
      commonStateActions.updateCommonStateReducerSuccess({
        hadShowNotification: showTooltip,
      })
    );
  }
}

export function uniqueByKey(array, key) {
  return [
    ...new Map(
      array
        // .filter(i => i[key])
        .map(item => [item[key], item])
    ).values(),
  ];
}

export function getPriceByCode(prices, code) {
  if (!prices || prices.length < 1 || !code) {
    return undefined;
  }
  return prices.filter(i => i.currency.code === code)[0];
}

export function checkNumber(value) {
  const reg = /^\d+$/gm;
  return reg.test(value);
}

/**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', 'unknown'.
 *
 * @returns {String}
 */
export function getMobileOperatingSystem() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(userAgent)) {
    return OPERATING_SYSTEM.ANDROID;
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return OPERATING_SYSTEM.IOS;
  }

  return OPERATING_SYSTEM.UNKNOWN;
}

export function handleShowRulesModal() {
  const store = getStore();

  store.dispatch(
    commonStateActions.updateCommonStateReducerSuccess({
      isShowRules: true,
    })
  );
}

export function handleAutoCloseRulesModal() {
  const store = getStore();
  if (store.getState().commonStateReducer.isShowRules) {
    store.dispatch(
      commonStateActions.updateCommonStateReducerSuccess({
        autoCloseRulesModal: true,
      })
    );
  }
}

export function openChatWithMember(userId, history, location) {
  const store = getStore();
  memberProfileService.getMemberProfile(userId).then(res => {
    if (res.success) {
      const { profileIntersection } = res.data;
      const isShowEmptyStateNoMatching = profileIntersection?.isFavoritedMutual || profileIntersection?.isLikedMutual || false;
      redirectMessengerInbox({ isShowEmptyStateNoMatching, userId, history, location });
    } else {
      store.dispatch(
        commonStateActions.updateCommonStateReducer({
          isErrorAPI: true,
        })
      );
    }
  });
}

export function redirectMessengerInbox({ isShowEmptyStateNoMatching, isGroup = false, userId, history, location, isOpenFullPage = false }) {
  const store = getStore();
  const { loginReducer } = store.getState();

  let encryptUserName = btoa(loginReducer.rhpUserName);
  encryptUserName = encryptUserName.replace(/=*$/g, '');

  const isMobile = phoneDetect();
  let targetUrl = isMobile || isOpenFullPage ? `${ROOT_FOLDER}/${HOME}` : location?.pathname;
  const searchNewParams = new URL(window.location.href).searchParams;

  // searchNewParams.set('d', userId === '' ? '' : 1);
  searchNewParams.set('userName', encryptUserName);
  searchNewParams.set('curNode', userId);
  if (userId !== '') {
    searchNewParams.set('isEmpty', isShowEmptyStateNoMatching);
    searchNewParams.set('gr', isGroup);
  }
  searchNewParams.delete('curOld');

  targetUrl += `?${searchNewParams}`;
  if (isMobile) {
    history.push(targetUrl);
    return;
  }
  if (!location?.pathname.includes(`${ROOT_FOLDER}/${HOME}`)) {
    if (isOpenFullPage) {
      history.push(targetUrl);
    } else {
      store.dispatch(conversationInboxAction.resetSelectedConversation());
      store.dispatch(
        conversationInboxAction.updateConversation({
          isShowChatModal: true,
          isMemberSearch: true,
        })
      );
      history.replace(targetUrl);
    }
  } else {
    // Fires an event to MessengerHomeContainer
    const event = new CustomEvent(SELECT_CONVERSATION_BY_IN_APP, {
      bubbles: true,
      cancelable: true,
      detail: {
        userId,
      },
    });

    window.dispatchEvent(event);
  }
}

export function handleShowParticipantsModal({ isView = false, eventId, title }) {
  const store = getStore();

  store.dispatch(
    commonStateActions.updateCommonStateReducerSuccess({
      participantInfo: {
        isShowParticipants: true,
        isView,
        eventId,
        title,
      },
    })
  );
}

export function handleShowReportModal(v2 = false) {
  const store = getStore();
  store.dispatch(userActions.toggleReportPopup(true, v2));
}

export function handleShowReportV2(data) {
  const store = getStore();
  store.dispatch(showReportV2Modal(data));
}

export function handleOpenInterestedModal(params, anotherParams) {
  const store = getStore();
  const {
    loginReducer: { userInfo },
    eventReducer: { dataDetailEvent },
  } = store.getState();

  store.dispatch(eventActions.mergeDataEvent({ ...params, isMyEvent: params.isMyEvent || false }));
  if (anotherParams && anotherParams.ignoreGetEventDetail) {
    const arrPromise = [];
    let funcInterest = 'getEventInterest';
    if (dataDetailEvent && dataDetailEvent.isViewerOwner && !anotherParams.ignoreGetGroupChatDetail) {
      arrPromise.push(store.dispatch(eventActions.getSearchGroupChat({ eventId: params.eventInterestId })));
    }

    if (dataDetailEvent && !dataDetailEvent.isGroupChatAvailable && (userInfo.userId === params.userId || params.isMyEvent)) {
      funcInterest = 'getUserEventInterest';
    }
    arrPromise.push(store.dispatch(eventActions[funcInterest]({ ID: params.eventInterestId })));

    if (arrPromise.length > 0) {
      Promise.all(arrPromise);
    }
  } else {
    Promise.all([
      store.dispatch(
        eventActions.getEventDetail({
          ID: params.eventInterestId,
          preview: true,
        })
      ),
    ]).then(res => {
      if (res[0].success) {
        const arrPromise = [];
        let funcInterest = 'getEventInterest';
        const { isGroupChatAvailable = false } = res[0].data;
        const paramsMerge = {
          isGroupChatAvailable: isGroupChatAvailable || false,
          isTicketUrlPrivate: (res[0].data && res[0].data.isTicketUrlPrivate) || false,
          isLoadingEventInterest: true,
          isLoadingUserEventInterest: false,
        };

        if (res[0].data.isViewerOwner) {
          arrPromise.push(store.dispatch(eventActions.getSearchGroupChat({ eventId: params.eventInterestId })));
        }

        if (!isGroupChatAvailable && (userInfo.userId === params.userId || params.isMyEvent)) {
          funcInterest = 'getUserEventInterest';
          paramsMerge.isLoadingEventInterest = false;
          paramsMerge.isLoadingUserEventInterest = true;
        }
        arrPromise.push(store.dispatch(eventActions[funcInterest]({ ID: params.eventInterestId })));

        if (arrPromise.length > 0) {
          Promise.all(arrPromise);
        }

        store.dispatch(eventActions.mergeDataEvent(paramsMerge));
      } else {
        store.dispatch(
          eventActions.mergeDataEvent({
            isLoadingEventInterest: false,
            isLoadingUserEventInterest: false,
            dataUserEventInterest: [],
            dataEventInterest: [],
            isHasMoreUserEventInterest: false,
            isHasMoreEventInterest: false,
          })
        );
      }
    });
  }
}

export function isCurrentUser(currentMessage, previousMessage) {
  return (
    !!currentMessage &&
    !!currentMessage.user &&
    !!previousMessage &&
    !!previousMessage.user &&
    !!currentMessage.user &&
    currentMessage.user.userId === previousMessage.user.userId
  );
}

export function coverSpaceToUnicode(text) {
  return (text && typeof text === 'string' && text.replace(/(?:\r\n|\r|\n)/g, '<br>')) || text;
}

export function coverEnterToUnicode(text) {
  return (text && typeof text === 'string' && text.replace(/<br\s*\/?>/gi, '\n')) || text;
}

// eslint-disable-next-line camelcase
export function array_move(arr, old_index, new_index) {
  // eslint-disable-next-line camelcase
  if (new_index >= arr.length) {
    // eslint-disable-next-line camelcase
    let k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr; // for testing
}

export function relativeFromDateToMinutes(fromDate, toDate) {
  /*
  * future: "in %s",
    past: "%s ago",
  * */
  const diffDay = moment(toDate).diff(fromDate, 'seconds');
  const isFuture = diffDay > 0;
  let res = isFuture ? 'in %s' : '%s ago';
  const diffSeconds = Math.abs(diffDay);
  if (diffSeconds <= 60) {
    res = res.replace('%s', `a minute`);
  } else {
    const diffMinute = Math.round(diffSeconds / 60);
    if (diffMinute <= 60) {
      res = res.replace('%s', `${diffMinute} ${diffMinute > 1 ? 'minutes' : 'minute'}`);
    } else {
      const diffHour = Math.round(diffMinute / 60);
      if (diffHour <= 24) {
        res = res.replace('%s', `${diffHour} ${diffHour > 1 ? 'hours' : 'hour'}`);
      } else {
        const diffDay = Math.round(diffHour / 24);
        res = res.replace('%s', `${diffDay} ${diffDay > 1 ? 'days' : 'day'}`);
      }
    }
  }

  return res;
}

export function getDataGalleryDisplay(galleryData) {
  if (isNative) {
    return galleryData?.slice?.(0, 3);
  }
  let numberItem = 4;
  if (isMobileWeb) {
    if (screen?.availWidth < 281) {
      numberItem = 2;
    } else {
      numberItem = 3;
    }
  }

  return galleryData?.slice?.(0, numberItem) || [];
}

export function formatTimeMessengerFromTimestampToTime(t) {}

export function formatPhoneNumber(phone) {
  return phone.replace(/\D+/g, '').replace(/(\d{2})(\d{3})(\d{3})(\d{3})/, '+$1 $2 $3 $4');
}

export function formatSpaceNumber(number) {
  const str = number.toString().replace(/\D+/g, '');
  const gr = [];
  for (let i = 0; i < str.length; i++) {
    let temp = (gr.length > 0 && gr[gr.length - 1]) || 3;
    if (temp === 3) {
      gr.push(1);
    } else {
      gr[gr.length - 1] += 1;
    }
  }
  let txtReplace = '';
  let txtParams = '';
  let i = gr.length - 1;
  let index = 1;
  while (i >= 0) {
    txtReplace += `(\\d{${gr[i]}})`;
    txtParams += `$${index} `;
    index += 1;
    i -= 1;
  }
  let regExp = new RegExp(txtReplace);

  return str.replace(regExp, txtParams.trim());
}

/**
 * using this function to get unavailablePopupShown data
 * @param resData: response.data
 * @return {{unavailablePopupShown: {messenger: boolean, chatroomSettings: boolean}}}
 */
export function getUnavailablePopupData(resData) {
  try {
    return {
      unavailablePopupShown: {
        messenger: !resData.Messenger.IsActive,
        chatroomSettings: !resData.ChatroomSettings.IsActive,
      },
    };
  } catch (e) {
    console.error('API return wrong data structure!', e);
    // We keep default value when there is a error here
    return {
      unavailablePopupShown: {
        messenger: false,
        chatroomSettings: false,
      },
    };
  }
}

export function mergeArrayIgnoreDuplicate(arrA, arrB, predicate = (a, b) => a === b) {
  const arrC = [...arrA];

  arrB.forEach(bItem => {
    if (!arrC.some(cItem => predicate(bItem, cItem))) {
      arrC.push(bItem);
    }
  });

  return arrC;
}

export function generateParamsRecentlyValidation(data) {
  const params = {
    Page: 1,
    Size: 24,
  };
  if (data) {
    if ((!!data.location && data.location.googleMapPlacesId) || (!!data.location && data.location.GoogleMapPlacesId)) {
      params.GoogleMapPlaceID = data.location.googleMapPlacesId || data.location.GoogleMapPlacesId;
    }
    if (!!data.page) {
      params.Page = data.page;
    }
    if (!!data.size) {
      params.Size = data.size;
    }
    if (
      !!data.showMeMemberType &&
      data.showMeMemberType.contentTabs &&
      data.showMeMemberType.contentTabs[0] &&
      data.showMeMemberType.contentTabs[0].data
    ) {
      let selectedItems = data.showMeMemberType.contentTabs[0].data.filter(subItem => subItem.active);
      selectedItems = selectedItems.map(subItem => subItem.id);
      if (selectedItems.length > 0 && selectedItems.reduce(sumArrayItem) > 0) {
        params.MemberType = selectedItems.reduce(sumArrayItem);
      }
    }
  }
  return params;
}

export function smartTrim(str, length, delim, appendix) {
  if (str.length <= length) return str;

  let trimmedStr = str.substr(0, length + delim.length);

  const lastDelimIndex = trimmedStr.lastIndexOf(delim);
  if (lastDelimIndex >= 0) trimmedStr = trimmedStr.substr(0, lastDelimIndex);

  if (trimmedStr) trimmedStr += appendix;
  return trimmedStr;
}

export function getClassByTheme(theme) {
  switch (theme) {
    case THEMES.PINK:
      return 'theme-pink';
    case THEMES.PURPLE:
      return 'theme-purple';
    case THEMES.BLUE:
      return 'theme-blue';
    default:
      return '';
  }
}

export function getFontClassByFont(font) {
  switch (font) {
    case FONT_SIZES.SMALL:
      return 'font-small';
    case FONT_SIZES.REGULAR:
      return 'font-regular';
    case FONT_SIZES.MEDIUM:
      return 'font-medium';
    case FONT_SIZES.LARGE:
      return 'font-large';
    case FONT_SIZES.HUGE:
      return 'font-huge';
    default:
      return '';
  }
}

export function getOriginByNative() {
  // TODO: native should handle to return origin here
  return config.isProduction ? urls.PROD_RHPURL : urls.DEV_RHPURL;
}

export function generateShareLinkGroupChat(shareToken, roomJid) {
  const origin = isNative ? getOriginByNative() : window.origin;
  return `${origin}${ROOT_FOLDER}/${QUICK_REGISTRATION}?bgt=vnl&type=${QUICK_REG_TYPE.GROUP_CHAT}&value=${encodeURIComponent(`${shareToken}_${roomJid}`)}`;
}

export function getBoostExpiryDuration(expiryTime, currentTime) {
  if (!expiryTime || !currentTime) return null;
  if (moment(expiryTime).isBefore(currentTime)) return null;
  const exp = moment(expiryTime);
  const now = moment(currentTime);
  return Math.round(exp.diff(now) / 1000);
}

export function formatExpiryTime(duration) {
  let ds = 86400;
  let format = 'HH:mm:ss';
  if (duration > ds) format = 'D';
  if (format === 'D') {
    return moment.utc(duration * 1000).format(format) > 1
      ? moment.utc(duration * 1000).format(format) + ' days'
      : moment.utc(duration * 1000).format(format) + ' day';
  }
  return moment.utc(duration * 1000).format(format);
}

export function isBoostedValid(expiredTime = 0) {
  return expiredTime >= new Date().getTime() + getStore().getState().conversationsReducer.chatServerTime;
}

export function generateShareLinkProfile(userId) {
  if (userId) {
    const origin = isNative ? getOriginByNative() : window.origin;
    return `${origin}${ROOT_FOLDER}/${QUICK_REGISTRATION}?bgt=vnl&type=${QUICK_REG_TYPE.PROFILE}&value=${encodeURIComponent(`${userId}`)}`;
  }
  return '';
}

export function generateShareLinkClub(clubId) {
  if (clubId) {
    const origin = isNative ? getOriginByNative() : window.origin;
    return `${origin}${ROOT_FOLDER}/${QUICK_REGISTRATION}?bgt=vnl&type=${QUICK_REG_TYPE.CLUB}&value=${encodeURIComponent(`${clubId}`)}`;
  }
  return '';
}

export function getMemberTypeTitleClass(userReceiveInfo) {
  let classname = '';
  switch (userReceiveInfo?.memberTypeId + '') {
    case SEX_TYPE.MEN:
      classname = 'text-male';
      break;
    case SEX_TYPE.WOMEN:
      classname = 'text-female';
      break;
    case SEX_TYPE.COUPLES:
      classname = 'text-couple';
      break;
    default:
      classname = 'text-default';
      break;
  }
  return classname;
}

export const calculateHighestCoinUnitPrice = storeCredits => {
  let price = 0;
  if (storeCredits?.length > 0) {
    storeCredits.forEach(storeCredit => {
      let coins = storeCredit.Name.split(' ')?.[0];
      let packageUnitPrice = storeCredit.Cost.Price / parseFloat(coins);
      if (packageUnitPrice > price) {
        price = packageUnitPrice;
      }
    });
  }
  return price;
};
export const calculateHighestCoinUnitPriceIOS = storeCredits => {
  let price = 0;
  if (storeCredits?.length > 0) {
    storeCredits.forEach(storeCredit => {
      let coins = storeCredit.name.split(' ')?.[0];
      let packageUnitPrice = parseFloat(storeCredit.price) / parseFloat(coins);
      if (packageUnitPrice > price) {
        price = packageUnitPrice;
      }
    });
  }
  return price;
};

export function formatDoubleNumber(num) {
  try {
    return Math.round(num * 100) / 100;
  } catch (err) {
    console.log(err);
  }
  return 0;
}

// START functions filter conversations

export function filterMatchingConversations(conversations) {
  if (conversations && conversations.length > 0) {
    return filterConversations(
      {
        primaryIndex: PRIMARY_FILTER.MATCHING,
        secondaryIndex: SECONDARY_FILTER.ALL_MESSAGES,
      },
      conversations
    );
  }
  return [];
}

export function filterSentConversations(conversations) {
  if (conversations && conversations.length > 0) {
    return filterConversations(
      {
        primaryIndex: PRIMARY_FILTER.ALL,
        secondaryIndex: SECONDARY_FILTER.MESSAGE_SENT,
      },
      conversations
    );
  }
  return [];
}

export function filterUnRepliedConversations(conversations) {
  if (conversations && conversations.length > 0) {
    return filterConversations(
      {
        primaryIndex: PRIMARY_FILTER.ALL,
        secondaryIndex: SECONDARY_FILTER.MESSAGE_NOT_REPLIED,
      },
      conversations
    );
  }
  return [];
}

export function filterUnreadConversations(conversations) {
  if (conversations && conversations.length > 0) {
    return filterConversations(
      {
        primaryIndex: PRIMARY_FILTER.ALL,
        secondaryIndex: SECONDARY_FILTER.MESSAGES_NOT_READ,
      },
      conversations
    );
  }
  return [];
}

export function filterMatchingUnreadConversations(conversations) {
  if (conversations && conversations.length > 0) {
    return filterConversations(
      {
        primaryIndex: PRIMARY_FILTER.MATCHING,
        secondaryIndex: SECONDARY_FILTER.MESSAGES_NOT_READ,
      },
      conversations
    );
  }
  return [];
}

export function filterMatchingUnRepliedConversations(conversations) {
  if (conversations && conversations.length > 0) {
    return filterConversations(
      {
        primaryIndex: PRIMARY_FILTER.MATCHING,
        secondaryIndex: SECONDARY_FILTER.MESSAGE_NOT_REPLIED,
      },
      conversations
    );
  }
  return [];
}

export function filterMatchingSentConversation(conversations) {
  if (conversations && conversations.length > 0) {
    return filterConversations(
      {
        primaryIndex: PRIMARY_FILTER.MATCHING,
        secondaryIndex: SECONDARY_FILTER.MESSAGE_SENT,
      },
      conversations
    );
  }
  return [];
}

export function filterNonMatchingConversations(conversations) {
  if (conversations && conversations.length > 0) {
    return filterConversations(
      {
        primaryIndex: PRIMARY_FILTER.ALL,
        secondaryIndex: SECONDARY_FILTER.MESSAGE_NON_MATCHING,
      },
      conversations
    );
  }
  return [];
}

export function filterIgnoredConversations(conversations) {
  if (conversations && conversations.length > 0) {
    return filterConversations(
      {
        primaryIndex: PRIMARY_FILTER.ALL,
        secondaryIndex: SECONDARY_FILTER.MESSAGES_IGNORED,
      },
      conversations
    );
  }
  return [];
}

export function filterFoldersConversations(conversations) {
  const res = {};
  for (const conv of conversations) {
    if (conv.folders.length > 0 && conv.message && conv.message.createdAt && !conv.isIgnored) {
      for (const folId of conv.folders) {
        if (!res[folId]) {
          res[folId] = [conv];
        } else {
          res[folId].push(conv);
        }
      }
    }
  }
  return res;
}

// END functions filter conversations
/**
 *
 * @param {*} param0
 */
export function handleShowPromoCodeSuccess({ title, description, okText, okAction, isApplySuccess, extraFooter }) {
  handleShowConfirmModal({
    messageConfirm: (
      <div className="promo-code-success-wrapper">
        <img src={isApplySuccess ? icCircleSuccess : icPartyPopper} alt="promo-code-success" />
        <span dangerouslySetInnerHTML={{ __html: title }} />
      </div>
    ),
    messageConfirmExternal: description,
    className: 'promo-code-success-content',
    okText,
    okAction: () => {
      if (typeof okAction === 'function') {
        okAction();
      }
      const store = getStore();
      store.dispatch(commonStateActions.updateCommonStateReducerSuccess({ disableShowTooltip: false }));
    },
    extraFooter: extraFooter && <div className="promo-code-success-footer">{extraFooter}</div>,
    disableCancel: true,
    disableClickOverlay: true,
    disableBackBrowserCloseModal: true,
    disableEscClose: true,
  });
}

export const generateParamsCreateGroup = data => {
  let params = {
    ProfileDetail: {
      ClubName: data.clubName,
      PrivacyType: data.privacy,
      VisibilityType: data.visibility,
      Description: data.description,
      Keywords: data.category,
      Rules: data.rules,
      EnableGuestInteraction: data.enableGuestInteraction,
      AllowAutoJoin: data.allowAutoJoin,
      CanMembersPost: data.canMembersPost,
    },
  };
  if (data.location) {
    params = {
      ...params,
      ProfileDetail: {
        ...params.ProfileDetail,
        GoogleMapPlace: {
          PlacesId: data.location.placeId,
          Types: [],
          LocationName: data.location.StateName,
        },
      },
    };
  }
  if (data.privacy === PrivacyOptionsValue.PUBLIC) {
    let memberType = 0;
    let selectedMemberType = data.whoCanJoin.memberType.filter(subItem => subItem.active);
    selectedMemberType = selectedMemberType.map(subItem => subItem.id);
    if (selectedMemberType.length > 0 && selectedMemberType[0].id !== -1) {
      memberType = selectedMemberType.reduce(sumArrayItem);
    }
    let memberSetting = {
      MinAge: data.whoCanJoin.ageMin,
      MaxAge: data.whoCanJoin.ageMax,
      MemberType: data.whoCanJoin.memberType,
    };
    if (memberType) {
      memberSetting = {
        ...memberSetting,
        MemberType: memberType,
      };
    }
    if (data.whoCanJoin.location) {
      memberSetting = {
        ...memberSetting,
        GoogleMapPlace:
          (data.whoCanJoin.location && {
            PlacesId: data.whoCanJoin.location.GoogleMapPlacesId,
            Types: [data.whoCanJoin.location.LocationType],
            LocationName: data.whoCanJoin.location.StateName,
          }) ||
          null,
      };
    }

    params = {
      ...params,
      MemberSetting: memberSetting,
    };
  }
  return params;
};

export const generateGroupAlert = typeAlert => {
  let txt = 'Your <b>type</b> has been <b>approvedType</b>';
  let approvedType;
  switch (typeAlert) {
    case GROUP_ALERT_TYPE.ALBUM_APPROVED:
      txt = txt.replace('type', 'album').replace('approvedType', 'approved');
      approvedType = true;
      break;
    case GROUP_ALERT_TYPE.ALBUM_REJECTED:
      txt = txt.replace('type', 'album').replace('approvedType', 'rejected');
      approvedType = false;
      break;
    case GROUP_ALERT_TYPE.CLUB_EVENT_APPROVED:
      txt = txt.replace('type', 'event').replace('approvedType', 'approved');
      approvedType = true;
      break;
    case GROUP_ALERT_TYPE.CLUB_EVENT_REJECTED:
      txt = txt.replace('type', 'event').replace('approvedType', 'rejected');
      approvedType = false;
      break;
    case GROUP_ALERT_TYPE.CLUB_POST_APPROVED:
      txt = txt.replace('type', 'post').replace('approvedType', 'approved');
      approvedType = true;
      break;
    case GROUP_ALERT_TYPE.CLUB_POST_REJECTED:
      txt = txt.replace('type', 'post').replace('approvedType', 'rejected');
      approvedType = false;
      break;
    case GROUP_ALERT_TYPE.CLUB_PHOTO_APPROVED:
      txt = txt.replace('type', 'photo').replace('approvedType', 'approved');
      approvedType = true;
      break;
    case GROUP_ALERT_TYPE.CLUB_PHOTO_REJECTED:
      txt = txt.replace('type', 'photo').replace('approvedType', 'rejected');
      approvedType = false;
      break;
    default:
      break;
  }
  return { txt: txt, approvedType: approvedType };
};

export const isCurrentDate = messageTs => {
  const currentDate = new Date();
  const messageDate = new Date(messageTs);

  return (
    currentDate.getFullYear() === messageDate.getFullYear() &&
    currentDate.getMonth() === messageDate.getMonth() &&
    currentDate.getDate() === messageDate.getDate()
  );
};

export const displayNumberCount = (count, maxCount = 99) => {
  return count > maxCount ? `+${maxCount}` : `+${count}`;
};

export const displayNumberCountV2 = (count, maxCount = 99) => {
  return count > maxCount ? `${maxCount}+` : `${count}`;
};

const addZero = number => {
  if (number < 10) {
    return `0${number}`;
  } else {
    return number.toString();
  }
};
export const dateData = date => {
  return {
    id: addZero(date.getDate()) + addZero(date.getMonth() + 1) + date.getFullYear().toString(),
    date: addZero(date.getDate()),
    day: date.getDay(),
    month: date.getMonth() + 1,
    year: date.getFullYear(),
    value: new Date(date.setHours(0, 0, 0, 0)),
  };
};
export const getDates = ({ maximumDateCount, startDate }) => {
  let now = startDate ? new Date(startDate) : new Date();
  let data = [];
  const maxCount = maximumDateCount ? maximumDateCount : 90;
  for (let index = 0; index < maxCount; index++) {
    let _date = now.addDays(index);
    data.push({
      id: dateData(_date).id,
      date: dateData(_date).date,
      day: dateData(_date).day,
      month: dateData(_date).month,
      year: dateData(_date).year,
      value: dateData(_date).value,
    });
  }
  return data;
};

export const isMoreThan3MinutesApart = (timestamp1, timestamp2) => {
  const diffMs = Math.abs(new Date(timestamp1) - new Date(timestamp2));
  return diffMs > 3 * 60 * 1000; // 3 phút = 180000 ms
};

export function isTextMoreThanTwoLines(str) {
  const lines = str.split(/\r?\n/);
  return lines.length > 2;
}

export function formatTimeDelta(momentObj) {
  /**
   * Formats a moment object as a string representing days, hours, minutes, or HH:mm:ss,
   * counting from now.
   *
   * @param {moment.Moment} momentObj - The moment object.
   * @returns {string} A string representing the time difference in the format
   * "Xd:Yh:Zm" if >= 1 hour, or "HH:mm:ss" if < 1 hour.
   */

  const now = moment();
  const delta = moment.duration(momentObj.diff(now));

  if (delta.asDays() >= 1) {
    const days = delta.days();
    const hours = delta.hours();
    const minutes = delta.minutes();

    return `${days}d:${hours}h:${minutes}m`;
  } else {
    const hours = delta.hours().toString().padStart(2, '0');
    const minutes = delta.minutes().toString().padStart(2, '0');
    const seconds = delta.seconds().toString().padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
  }
}
export function convertMsDateToUnixTimestamp(msDateString) {
  // 1. Extract the timestamp (milliseconds part)
  const match = msDateString.match(/\/Date\((\d+)([-+]\d{4})?\)\//);
  if (msDateString === '0' || msDateString.includes('253402272000000')) {
    return 0;
  }
  if (match && match[1]) {
    const milliseconds = parseInt(match[1], 10);

    // 2. Convert milliseconds to UNIX timestamp (seconds)
    const unixTimestamp = Math.floor(milliseconds / 1000);
    return unixTimestamp;
  } else {
    // Handle invalid input string
    console.error('Invalid MS Date String:', msDateString);
    return null; // Or throw an error, or return NaN, depending on desired error handling
  }
}

export function getEventInterestMatchingText(item) {
  const searchGuestType = item?.searchItem?.guestType || item?.guestType || item?.contentItem?.guestType || [];
  const detailGuestTypes =
    item?.detail?.guestTypes || item?.guestTypes || item?.contentItem?.guestTypes || item?.searchItem?.guestTypes || [];
  let text = '';
  let guestType = searchGuestType.length > 0 ? searchGuestType : detailGuestTypes.length > 0 ? detailGuestTypes : [];

  if (guestType.length > 0) {
    guestType.forEach(i => {
      text = text && text.length > 0 ? text + ', ' + i.text : i.text;
    });
  }
  const ageMax =
    item?.detail?.ageMax ||
    item?.searchItem?.ageMax ||
    item?.detail?.ageRange?.ageMax ||
    item?.ageRange?.ageMax ||
    item?.ageMax ||
    item?.contentItem?.ageMax;
  const ageMin =
    item?.detail?.ageMin ||
    item?.searchItem?.ageMin ||
    item?.detail?.ageRange?.ageMin ||
    item?.ageRange?.ageMin ||
    item?.ageMin ||
    item?.contentItem?.ageMin;
  let ageBetween = ageMax && ageMin ? `(${ageMin} - ${ageMax} yo)` : null;
  if (ageBetween) {
    text = text + '. ' + ageBetween;
  }
  return text;
}

/**
 * Recursively removes a comment or reply with a specific commentId,
 * modifying the array in place, and returns the modified array.
 * * @param {Array<any>} commentsArray The array of top-level comment objects.
 * @param {number} commentIdToRemove The ID of the comment/reply to remove.
 * @returns {Array<any>} The modified array of comments.
 */
export function removeComment(commentsArray, commentIdToRemove) {
  if (!commentsArray || commentsArray.length === 0) {
    return commentsArray; // Return the array as is if it's empty
  }

  // Iterate through the array to find the comment/reply
  for (let i = 0; i < commentsArray.length; i++) {
    const comment = commentsArray[i];

    // 1. Check for a match at the current level
    if (comment.commentId === commentIdToRemove) {
      commentsArray.splice(i, 1);
      console.log(`Removed comment with ID: ${commentIdToRemove}`);
      return commentsArray; // Return immediately after removal
    }

    // 2. Recursively check the replies array
    if (comment.replies && comment.replies.length > 0) {
      // NOTE: The recursive call modifies 'comment.replies' in place.
      // If the reply is removed, the original 'commentsArray' is updated via reference.
      const initialReplyCount = comment.replies.length;

      // Call the function recursively on the replies array
      removeComment(comment.replies, commentIdToRemove);

      // Check if the replies array length changed (i.e., a reply was removed)
      if (comment.replies.length < initialReplyCount) {
        // If you have a 'replyCount' property, you might want to update it here.
        if (typeof comment.replyCount === 'number') {
          comment.replyCount -= 1;
        }
        return commentsArray; // Return immediately after a deep removal
      }
    }
  }

  return commentsArray; // Return the array if no comment was removed
}

/**
 * Recursively maps over the comments array to find and update the like status
 * for a comment or reply with a specific ID, ensuring immutability.
 * * @param {Array<any>} commentsArray The array of comments or replies to search.
 * @param {number} commentIdToUpdate The ID of the comment/reply to modify.
 * @param {boolean} isLike The new like status (true for like, false for unlike).
 * @returns {Array<any>} A new array with the target comment/reply updated.
 */
export const updateCommentLike = (commentsArray, commentIdToUpdate, isLike) => {
  return commentsArray.map(cmt => {
    // 1. Check if the current comment is the target
    if (cmt.commentId === commentIdToUpdate) {
      // Found the target! Update its properties immutably.
      return {
        ...cmt,
        isLiked: isLike,
        // Increment or decrement likeCount based on isLike
        likeCount: cmt.likeCount + (isLike ? 1 : -1),
      };
    }

    // 2. If not the target, check its replies (if any)
    if (cmt.replies && cmt.replies.length > 0) {
      // Recursively process the replies array
      const updatedReplies = updateCommentLike(cmt.replies, commentIdToUpdate, isLike);

      // If the replies array changed, it means the target was a reply,
      // so return a *new* parent comment object with the updated replies.
      if (updatedReplies !== cmt.replies) {
        return {
          ...cmt,
          replies: updatedReplies,
        };
      }
    }

    // 3. If neither the comment nor its replies were updated, return the comment unchanged
    return cmt;
  });
};

/**
 * Recursively filters an array of comments (and their nested replies)
 * to remove any items where the profile.userId matches the targetUserId.
 *
 * @param {Array<any>} comments The array of comment objects to filter.
 * @param {number | string} targetUserId The user ID to exclude.
 * @returns {Array<any>} A new array containing only comments and replies
 * that do not match the targetUserId.
 */
export function filterCommentsByUser(comments, targetUserId) {
  if (!Array.isArray(comments)) {
    // Handle the case where the input is not an array (e.g., if you pass
    // a single comment object by mistake, or it's falsy)
    return [];
  }

  // Use .filter() to create a new array, preserving immutability
  const filteredComments = comments.filter(comment => {
    // 1. Check if the current comment belongs to the user
    const isCommentByTargetUser = comment.profile && comment.profile.userId === targetUserId;

    // If the main comment belongs to the user, we skip it entirely
    if (isCommentByTargetUser) {
      return false;
    }

    // 2. Recursively filter the replies array if it exists
    if (comment.replies && comment.replies.length > 0) {
      // Apply the filter function recursively
      const filteredReplies = filterCommentsByUser(comment.replies, targetUserId);

      // Overwrite the replies array with the new filtered array
      comment.replies = filteredReplies;
    }

    // 3. Keep the current comment (it wasn't by the target user)
    return true;
  });

  return filteredComments;
}

/**
 *
 * @param {*} duration: in ms
 * @returns
 */
export function formatAudioDuration(duration) {
  const totalSeconds = Math.floor(duration / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
}

/**
 * Calculates the Standard Time offset (in hours) for the host system's timezone.
 * This works by checking the offset on a date when Daylight Saving Time (DST)
 * is guaranteed *not* to be in effect in the Northern and Southern Hemispheres.
 * @returns {number} The standard timezone offset in hours (e.g., -10 for AEST).
 */
export function getStandardTimeOffsetHours() {
  const today = new Date();
  const currentYear = today.getFullYear();

  // 1. Create a date in a month where DST is typically NOT active in the Southern Hemisphere (like Sydney).
  // July 1st is typically Standard Time in Sydney (AEST).
  const standardTimeDate = new Date(currentYear, 6, 1); // Month 6 is July

  // 2. Get the offset for that date in minutes.
  // This value is (UTC - Local Time) in minutes.
  const standardOffsetMinutes = standardTimeDate.getTimezoneOffset();

  // 3. Convert minutes to hours.
  const standardOffsetHours = standardOffsetMinutes / 60;

  return standardOffsetHours;
}

export const getLangQueryParams = params => {
  if (!params?.lang) {
    return {};
  }

  return { lang: params.lang };
};
